import * as React from 'react';
import { forwardRef, useContext, useMemo, useState, useEffect, useImperativeHandle, Fragment as Fragment$1, memo, isValidElement } from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import cn from 'classnames';
import NextLink from 'next/link';
import Chip from '@mui/material/Chip';
import { styled, emphasize } from '@mui/material/styles';
import * as ReactJSXRuntime from 'react/jsx-runtime';
import { CloneElement, formatNumbering, useDeepCompareEffect } from '@crudx/common';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import isNil from 'lodash/isNil';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import isArray from 'lodash/isArray';
import Skeleton from '@mui/material/Skeleton';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableContainer from '@mui/material/TableContainer';
import MuiTableFooter from '@mui/material/TableFooter';
import MuiTableRow from '@mui/material/TableRow';
import uniq from 'lodash/uniq';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import TableSortLabel from '@mui/material/TableSortLabel';
import isEmpty from 'lodash/isEmpty';
import MuiTable from '@mui/material/Table';
import MuiTableHead from '@mui/material/TableHead';
import MUITablePagination from '@mui/material/TablePagination';
import Collapse from '@mui/material/Collapse';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import replace$3 from 'lodash/replace';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import toast from 'react-hot-toast';
import { CRUD } from '@crudx/core';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import omit from 'lodash/omit';
import reduce from 'lodash/reduce';
import { Typography as Typography$1, MenuItem as MenuItem$1 } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from '@mui/material/Pagination';
import CachedIcon from '@mui/icons-material/Cached';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import forEach from 'lodash/forEach';
import capitalize from 'lodash/capitalize';
import includes from 'lodash/includes';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ExpandCircleDownOutlinedIcon from '@mui/icons-material/ExpandCircleDownOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import startCase from 'lodash/startCase';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$e = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$d = fails$e;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$d(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$c = fails$e;

var functionBindNative = !fails$c(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$6 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$6.bind(call$6) : function () {
  return call$6.apply(call$6, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$5 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$5, call$5);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$5.apply(fn, arguments);
  };
};

var uncurryThis$d = functionUncurryThis;

var toString$5 = uncurryThis$d({}.toString);
var stringSlice$1 = uncurryThis$d(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$5(it), 8, -1);
};

var uncurryThis$c = functionUncurryThis;
var fails$b = fails$e;
var classof$4 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$c(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$b(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$4(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$8 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$4 = function (it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$8("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$3 = requireObjectCoercible$4;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$3(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$f = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$e = isCallable$f;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$7 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var global$c = global$d;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$b = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$b({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match$1, version;

if (v8) {
  match$1 = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match$1[0] > 0 && match$1[0] < 4 ? 1 : +(match$1[0] + match$1[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match$1 = userAgent.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent.match(/Chrome\/(\d+)/);
    if (match$1) version = +match$1[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = engineV8Version;
var fails$a = fails$e;
var global$a = global$d;

var $String$5 = global$a.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$a(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$c = isCallable$f;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

var $TypeError$7 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$3 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw $TypeError$7(tryToString(argument) + ' is not a function');
};

var aCallable$2 = aCallable$3;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$2(func);
};

var call$4 = functionCall;
var isCallable$a = isCallable$f;
var isObject$6 = isObject$7;

var $TypeError$6 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$6(val = call$4(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$6(val = call$4(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$6(val = call$4(fn, input))) return val;
  throw $TypeError$6("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$9 = global$d;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$5(global$9, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$9[key] = value;
  } return value;
};

var global$8 = global$d;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$8[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$2 = requireObjectCoercible$4;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return $Object$2(requireObjectCoercible$2(argument));
};

var uncurryThis$a = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty$1 = uncurryThis$a({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$1(toObject$3(it), key);
};

var uncurryThis$9 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$4 = uncurryThis$9(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$4(++id + postfix, 36);
};

var global$7 = global$d;
var shared$2 = shared$3.exports;
var hasOwn$8 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = global$7.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$a = function (name) {
  if (!hasOwn$8(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$8(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$3 = functionCall;
var isObject$5 = isObject$7;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$9 = wellKnownSymbol$a;

var $TypeError$5 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$9('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$5(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$3(exoticToPrim, input, pref);
    if (!isObject$5(result) || isSymbol$1(result)) return result;
    throw $TypeError$5("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$6 = global$d;
var isObject$4 = isObject$7;

var document$1 = global$6.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$4(document$1) && isObject$4(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$9 = fails$e;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$9(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$8 = descriptors;
var call$2 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$7 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$7(O, P)) return createPropertyDescriptor$2(!call$2(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$7 = descriptors;
var fails$8 = fails$e;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$7 && fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$3 = isObject$7;

var $String$3 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$5 = function (argument) {
  if (isObject$3(argument)) return argument;
  throw $TypeError$4($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$4 = anObject$5;
var toPropertyKey = toPropertyKey$2;

var $TypeError$3 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$4(O);
  P = toPropertyKey(P);
  anObject$4(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$4(O);
  P = toPropertyKey(P);
  anObject$4(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$3('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$6 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$6(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$8 = functionUncurryThis;
var isCallable$9 = isCallable$f;
var store$1 = sharedStore;

var functionToString = uncurryThis$8(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$5 = global$d;
var isCallable$8 = isCallable$f;

var WeakMap$2 = global$5.WeakMap;

var weakMapBasicDetection = isCallable$8(WeakMap$2) && /native code/.test(String(WeakMap$2));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$4 = global$d;
var isObject$2 = isObject$7;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$5 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$4.TypeError;
var WeakMap$1 = global$4.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$2(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$5(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$5(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$5(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$7 = functionUncurryThis;
var fails$7 = fails$e;
var isCallable$7 = isCallable$f;
var hasOwn$4 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;
var stringSlice = uncurryThis$7(''.slice);
var replace$2 = uncurryThis$7(''.replace);
var join = uncurryThis$7([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$7(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (stringSlice($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$2($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$4(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$4(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$4(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$4(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$7(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$6 = isCallable$f;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$3 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$6(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$2 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$1 = lengthOfArrayLike$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$1(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$6 = functionUncurryThis;
var hasOwn$3 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$6([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$3(hiddenKeys$2, key) && hasOwn$3(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$3(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$5 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$3 = anObject$5;

var concat$1 = uncurryThis$5([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$3(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$2 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$2(target, key) && !(exceptions && hasOwn$2(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$6 = fails$e;
var isCallable$5 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$5(detection) ? fails$6(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$3 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$2 = defineBuiltIn$3;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$3;
  } else if (STATIC) {
    target = global$3[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$3[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$2(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$2 = descriptors;
var uncurryThis$4 = functionUncurryThis;
var call$1 = functionCall;
var fails$5 = fails$e;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat = uncurryThis$4([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$5(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$5 = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$5({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledChip = styled(Chip)(({
  theme
}) => {
  const backgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06)
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12)
    }
  };
});

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (process.env.NODE_ENV !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (process.env.NODE_ENV !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace$1 (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? charat(characters, --position) : 0;

	if (column--, character === 10)
		column = 1, line--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? charat(characters, position++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace$1(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace$1(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace$1(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace$1(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace$1(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace$1(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace$1(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace$1(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace$1(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace$1(value, '-grow', '') + WEBKIT + value + MS + replace$1(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace$1(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace$1(replace$1(replace$1(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace$1(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace$1(replace$1(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace$1(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace$1(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace$1(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace$1(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace$1(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace$1(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace$1(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace$1(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace$1(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace$1(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var isBrowser$4 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize(function () {
  return memoize(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (process.env.NODE_ENV !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (process.env.NODE_ENV !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, process.env.NODE_ENV !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

var isBrowser$3 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error(noComponentSelectorMessage);
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$2 ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect;

var isBrowser$1 = typeof document !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

if (process.env.NODE_ENV !== 'production') {
  EmotionCacheContext.displayName = 'EmotionCacheContext';
}

EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$1) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'EmotionThemeContext';
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (process.env.NODE_ENV !== 'production' && !!props.css && (typeof props.css !== 'object' || typeof props.css.name !== 'string' || props.css.name.indexOf('-') === -1)) {
    var label = getLabelFromStackTrace(new Error().stack);
    if (label) newProps[labelPropName] = label;
  }

  return newProps;
};

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$1 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext));

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
}

var Emotion$1 = Emotion;

var Fragment = ReactJSXRuntime.Fragment;
function jsx$1(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return ReactJSXRuntime.jsx(type, props, key);
  }

  return ReactJSXRuntime.jsx(Emotion$1, createEmotionProps(type, props), key);
}
function jsxs(type, props, key) {
  if (!hasOwnProperty.call(props, 'css')) {
    return ReactJSXRuntime.jsxs(type, props, key);
  }

  return ReactJSXRuntime.jsxs(Emotion$1, createEmotionProps(type, props), key);
}

const _excluded$d = ["type", "current", "className", "items", "chipProps", "textProps", "linkProps"];
const BreadcrumbView = props => {
  const {
      type = 'default',
      current,
      className,
      items = [],
      chipProps,
      textProps,
      linkProps
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$d);

  // =============== VIEWS
  return jsx$1(Breadcrumbs, Object.assign({
    className: cn('breadcrumb-view-wrapper', className)
  }, restProps, {
    children: items.map((e, i) => {
      const {
        url,
        label,
        icon
      } = e;
      const isMatched = current === url;

      // if display type = chip
      if (type === 'chip') {
        if (url && !isMatched) {
          return jsx$1(Link, Object.assign({
            href: url,
            color: "inherit",
            component: NextLink
          }, linkProps, {
            children: jsx$1(StyledChip, Object.assign({
              icon: icon,
              label: label
            }, chipProps))
          }), i);
        }
        return jsx$1(StyledChip, Object.assign({
          icon: icon,
          label: label
        }, chipProps, {
          disabled: isMatched
        }), i);
      }

      // if no url provided, then use typography instead
      if (!url) {
        return jsxs(Typography, Object.assign({
          sx: {
            display: 'flex',
            alignItems: 'center'
          },
          color: "inherit"
        }, textProps, {
          children: [icon, label]
        }), i);
      }

      // if url is provided
      return jsxs(Link, Object.assign({
        href: url,
        sx: {
          display: 'flex',
          alignItems: 'center'
        },
        color: "inherit",
        underline: "hover",
        component: NextLink
      }, linkProps, {
        children: [icon, label]
      }), i);
    })
  }));
};

var objectDefineProperties = {};

var DESCRIPTORS$1 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$2 = anObject$5;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$1 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$2(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$1 = anObject$5;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$1(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$8 = wellKnownSymbol$a;
var create$1 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$4 = fails$e;

var correctPrototypeGetter = !fails$4(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$1 = hasOwnProperty_1;
var isCallable$4 = isCallable$f;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$3 = fails$e;
var isCallable$3 = isCallable$f;
var isObject$1 = isObject$7;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$1 = defineBuiltIn$3;
var wellKnownSymbol$7 = wellKnownSymbol$a;

var ITERATOR$3 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype$2) || fails$3(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$2[ITERATOR$3])) {
  defineBuiltIn$1(IteratorPrototype$2, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn = hasOwnProperty_1;
var wellKnownSymbol$6 = wellKnownSymbol$a;

var TO_STRING_TAG$3 = wellKnownSymbol$6('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG$3)) {
    defineProperty$1(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$3 = functionUncurryThis;
var aCallable$1 = aCallable$3;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$3(aCallable$1(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$2 = isCallable$f;

var $String$1 = String;
var $TypeError$2 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$2(argument)) return argument;
  throw $TypeError$2("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject = anObject$5;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$4 = _export;
var call = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$f;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn = defineBuiltIn$3;
var wellKnownSymbol$5 = wellKnownSymbol$a;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$5('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$2])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$4({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$2, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$2 = global$d;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$4 = wellKnownSymbol$a;

var ITERATOR$1 = wellKnownSymbol$4('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$4('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$1] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$1, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$1] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$2[COLLECTION_NAME] && global$2[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const _excluded$c = ["enabled", "title", "children"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TooltipView = props => {
  const {
      enabled,
      title,
      children
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$c);

  // =============== VARIABLES
  const isEnabled = useMemo(() => {
    if (isNil(enabled)) return !!title;
    return enabled;
  }, [title, enabled]);

  // =============== VIEWS
  // if tooltip  or title not defined then return children
  if (!isEnabled) return children;
  return jsx$1(Tooltip, Object.assign({
    title: title
  }, restProps, {
    children: children
  }));
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const ButtonDropdown = props => {
  var _ref, _render;
  const {
    className,
    type = 'button',
    size = 'small',
    variant = 'text',
    tooltip,
    items = [],
    selected,
    buttonProps,
    menuProps,
    menuItemProps,
    children,
    render,
    onItemClick
  } = props;

  // =============== STATE
  const [anchorEl, setAnchorEl] = useState(null);

  // =============== EVENTS
  const handleClick = event => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // =============== VARIABLES
  const open = Boolean(anchorEl);
  const Elem = useMemo(() => {
    return type === 'button' ? Button : IconButton;
  }, [type]);

  // =============== VIEWS
  const renderButton = node => {
    if (!tooltip) return node;
    if (typeof tooltip === 'string') {
      return jsx$1(TooltipView, {
        title: tooltip,
        children: node
      });
    }
    return jsx$1(TooltipView, Object.assign({}, tooltip, {
      children: node
    }));
  };
  return jsxs(Fragment, {
    children: [renderButton(jsx$1(Elem, Object.assign({
      size: size,
      variant: variant,
      className: cn('button-dropdown-view', className),
      "aria-controls": open ? 'button-dropdown-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": open ? 'true' : undefined,
      onClick: handleClick
    }, buttonProps, {
      children: (_ref = (_render = render == null ? void 0 : render({
        open,
        element: anchorEl
      })) != null ? _render : children) != null ? _ref : jsx$1(MoreHorizIcon, {})
    }))), jsx$1(Menu, Object.assign({
      className: "button-dropdown-menu",
      "aria-labelledby": "button-dropdown",
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      }
    }, menuProps, {
      children: items.map(e => {
        if (e.as) {
          return jsx$1(CloneElement, Object.assign({}, menuItemProps, e.props, {
            selected: e.key === selected,
            onClick: event => {
              event.stopPropagation();
              handleClose();
              e.onClick == null ? void 0 : e.onClick();
              onItemClick == null ? void 0 : onItemClick(e.key);
            },
            children: e.as
          }), e.key);
        }
        return jsx$1(MenuItem, Object.assign({}, menuItemProps, e.props, {
          selected: e.key === selected,
          onClick: event => {
            event.stopPropagation();
            event.preventDefault();
            handleClose();
            e.onClick == null ? void 0 : e.onClick();
            onItemClick == null ? void 0 : onItemClick(e.key);
          },
          children: e.title
        }), e.key);
      })
    }))]
  });
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const getDialogActions = (type, actions = [], text) => {
  var _text$secondaryText, _text$primaryText, _text$primaryText2;
  // if has input actions then override default action
  if (actions.length > 0) return actions;

  // if there is no input actions, use default
  switch (type) {
    case 'confirmation':
      return [{
        type: 'secondary',
        label: (_text$secondaryText = text == null ? void 0 : text.secondaryText) != null ? _text$secondaryText : 'Cancel',
        props: {}
      }, {
        type: 'primary',
        label: (_text$primaryText = text == null ? void 0 : text.primaryText) != null ? _text$primaryText : 'Confirm',
        props: {}
      }];
    case 'info':
    case 'error':
    case 'success':
    case 'warning':
      return [{
        type: 'primary',
        label: (_text$primaryText2 = text == null ? void 0 : text.primaryText) != null ? _text$primaryText2 : 'OK'
      }];
    default:
      return [];
  }
};

const _excluded$b = ["type", "primaryButtonVariant", "secondaryButtonVariant", "icon", "title", "message", "visible", "disableEscapeClose", "disableBackdropClose", "enableCloseButton", "actions", "titleProps", "contentProps", "messageProps", "actionProps", "children", "primaryText", "secondaryText", "onClose", "onClickAction", "onClickPrimaryAction", "onClickSecondaryAction"];
const Dialog = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      type = 'info',
      primaryButtonVariant = 'text',
      secondaryButtonVariant = 'text',
      icon,
      title,
      message,
      visible = false,
      disableEscapeClose = false,
      disableBackdropClose = false,
      enableCloseButton = false,
      actions = [],
      titleProps,
      contentProps,
      messageProps,
      actionProps,
      children,
      primaryText,
      secondaryText,
      onClose,
      onClickAction,
      onClickPrimaryAction,
      onClickSecondaryAction
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$b);

  // =============== VARIABLES
  const dialogActions = getDialogActions(type, actions, {
    primaryText,
    secondaryText
  });

  // =============== STATE
  const [visibleState, setVisibleState] = useState(visible);

  // =============== EFFECTS
  useEffect(() => setVisibleState(visible), [visible]);

  // =============== HOOKS
  useImperativeHandle(ref, () => {
    return {
      toggle: inState => {
        if (!isNil(inState)) {
          setVisibleState(inState);
          return;
        }
        setVisibleState(!visibleState);
      },
      open: () => setVisibleState(true),
      close: () => setVisibleState(false)
    };
  });

  // =============== EVENTS
  const onHandleClose = () => {
    setVisibleState(false);
  };
  const onHandleClick = action => {
    return e => {
      var _action$key;
      e.preventDefault();
      e.stopPropagation();
      switch (action.type) {
        case 'primary':
          onClickPrimaryAction == null ? void 0 : onClickPrimaryAction();
          onClickAction == null ? void 0 : onClickAction('primary');
          break;
        case 'secondary':
          onClickSecondaryAction == null ? void 0 : onClickSecondaryAction();
          onClickAction == null ? void 0 : onClickAction('secondary');
          break;
        default:
          onClickAction == null ? void 0 : onClickAction((_action$key = action.key) != null ? _action$key : action.type);
          break;
      }
      onHandleClose();
    };
  };

  // =============== VIEWS
  return jsxs(MuiDialog, Object.assign({}, restProps, {
    open: visibleState,
    onClose: (event, reason) => {
      if (disableBackdropClose && reason === 'backdropClick') {
        return;
      }
      if (disableEscapeClose && reason === 'escapeKeyDown') {
        return;
      }
      setVisibleState(false);
      onClose == null ? void 0 : onClose(event, reason);
    },
    children: [enableCloseButton && jsx$1(IconButton, {
      "aria-label": "close",
      onClick: () => {
        onClickAction == null ? void 0 : onClickAction('close');
        onHandleClose();
      },
      sx: {
        position: 'absolute',
        right: 10,
        top: 10,
        color: theme => theme.palette.grey[500]
      },
      children: jsx$1(CloseIcon, {})
    }), title && jsx$1(DialogTitle, Object.assign({}, titleProps, {
      children: jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1,
        children: [icon != null ? icon : jsxs(Fragment, {
          children: [type === 'confirmation' && jsx$1(InfoOutlined, {}), type === 'info' && jsx$1(InfoOutlined, {}), type === 'success' && jsx$1(CheckCircleOutlineIcon, {}), type === 'error' && jsx$1(ErrorOutlineIcon, {}), type === 'warning' && jsx$1(WarningAmberIcon, {})]
        }), title]
      })
    })), jsxs(DialogContent, Object.assign({}, contentProps, {
      children: [message && jsx$1(DialogContentText, Object.assign({}, messageProps, {
        children: message
      })), children]
    })), dialogActions.length > 0 && jsx$1(DialogActions, Object.assign({}, actionProps, {
      children: dialogActions.map((action, i) => {
        const type = action.type;
        const variant = type === 'primary' ? primaryButtonVariant : secondaryButtonVariant;
        return jsx$1(Button, Object.assign({
          variant: type === 'custom' ? 'text' : variant
        }, action.props, {
          onClick: onHandleClick(action),
          children: action.label
        }), `${action.label}-${i}`);
      })
    }))]
  }));
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const NumberFormatView = props => {
  const {
    prefix,
    postfix,
    amount = 0,
    format = '0,0'
  } = props;

  // =============== EVENTS
  const display = useMemo(() => {
    return formatNumbering(amount, format);
  }, [amount, format]);

  // =============== VIEWS
  return jsxs(Fragment, {
    children: [prefix, display, postfix]
  });
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const RenderFlexView = props => {
  const {
    className,
    items = [],
    containerProps,
    itemProps
  } = props;

  // =============== VIEWS
  return jsx$1(Fragment, {
    children: items.map((row, rowIndex) => {
      const isItemArray = isArray(row);
      return jsx$1(Grid, Object.assign({
        container: true,
        className: className,
        spacing: 2
      }, containerProps, isItemArray ? {} : row.props, {
        children: isItemArray ? row.map((item, itemIndex) => {
          return jsx$1(Grid, Object.assign({
            item: true
          }, item), `grid-item-${rowIndex}-${itemIndex}`);
        }) : row.items.map((item, itemIndex) => {
          return jsx$1(Grid, Object.assign({
            item: true
          }, itemProps, item), `item-${rowIndex}-${itemIndex}`);
        })
      }), `container-${rowIndex}`);
    })
  });
};

const _excluded$a = ["className", "items"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const RenderNodeView = props => {
  const {
      className,
      items = []
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$a);

  // =============== VIEWS
  return jsx$1(Stack, Object.assign({
    className: className,
    direction: "row",
    alignItems: "center"
  }, restProps, {
    children: items.map((e, i) => {
      const {
        key,
        content
      } = e;
      return jsx$1(Fragment$1, {
        children: typeof content === 'function' ? content() : content
      }, key);
    })
  }));
};

var aCallable = aCallable$3;
var toObject = toObject$4;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$2;

var $TypeError$1 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$2 = fails$e;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$2(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var classof$3 = classofRaw$1;

var engineIsNode = typeof process != 'undefined' && classof$3(process) == 'process';

var $$3 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$3({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var $$2 = _export;
var $includes = arrayIncludes.includes;
var fails$1 = fails$e;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$1(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$2({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$7;
var classof$2 = classofRaw$1;
var wellKnownSymbol$3 = wellKnownSymbol$a;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$2 = wellKnownSymbol$a;

var TO_STRING_TAG$1 = wellKnownSymbol$2('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol$1 = wellKnownSymbol$a;

var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString$3 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var wellKnownSymbol = wellKnownSymbol$a;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$1 = _export;
var uncurryThis$2 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$4;
var toString$2 = toString$3;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$2(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$1({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$2(requireObjectCoercible$1(this)),
      toString$2(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};
var visuallyHidden$1 = visuallyHidden;

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledTable = styled(MuiTable, {
  shouldForwardProp: prop => !['striped', 'bordered'].includes(prop)
})(props => {
  const {
    striped,
    bordered,
    theme
  } = props;
  return Object.assign({
    borderCollapse: 'separate'
  }, !striped ? {} : {
    '.table-row:nth-of-type(odd) td': {
      background: theme.palette.action.hover
    }
  }, {
    // hide last border'
    '.table-row:last-child td, .table-row:last-child th': {
      border: 0
    }
  }, bordered ? {} : {
    '.table-row td': {
      border: 0
    }
  });
});
const StyledPaginationWrapper = styled(Box)(props => {
  const {
    theme
  } = props;
  return {
    borderTop: `1px solid ${theme.palette.divider}`
  };
});
const StyledTableCell = styled(MuiTableCell, {
  shouldForwardProp: prop => !['striped', 'bordered', 'sticky'].includes(prop)
})(props => {
  const {
    sticky
  } = props;
  return Object.assign({}, !sticky ? {} : {
    left: 0,
    zIndex: 1,
    position: 'sticky !important'
  });
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledTableHead = styled(MuiTableHead, {
  shouldForwardProp: prop => !['divider', 'options', 'stickyHeader', 'columnBorder', 'backgroundColor'].includes(prop)
})(props => {
  var _options$color, _options$width, _options$height;
  const {
    divider,
    options,
    theme,
    stickyHeader,
    columnBorder,
    backgroundColor
  } = props;
  const isBorderPreset = columnBorder === 'preset';
  const dividerColor = (_options$color = options == null ? void 0 : options.color) != null ? _options$color : theme.palette.divider;
  const dividerWidth = (_options$width = options == null ? void 0 : options.width) != null ? _options$width : 1;
  const borderStyle = isBorderPreset ? {
    position: 'relative',
    '::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: dividerWidth,
      height: (_options$height = options == null ? void 0 : options.height) != null ? _options$height : '40%',
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: 'auto',
      marginBottom: 'auto',
      background: dividerColor
    },
    ':last-child::after': {
      content: 'none'
    }
  } : {
    borderTop: `${dividerWidth}px solid ${dividerColor}`,
    borderBottom: `${dividerWidth}px solid ${dividerColor}`,
    borderRight: `${dividerWidth}px solid ${dividerColor}`,
    ':not(&.table-head-group-item):first-child': {
      borderLeft: `${dividerWidth}px solid ${dividerColor}`
    },
    '&.table-head-group-item': {
      borderTop: 'none'
    }
  };
  return Object.assign({
    background: backgroundColor,
    '.MuiTableCell-head': Object.assign({}, divider ? borderStyle : {})
  }, !stickyHeader ? {} : {
    position: 'sticky',
    top: 0,
    zIndex: 3
  });
});

const _excluded$9 = ["className", "columns", "checked", "sorting", "checkbox", "tableRowProps", "divider", "dividerProps", "stickyHeader", "columnBorder", "backgroundColor", "onSort", "onCheckAll"];
const TableHead = props => {
  var _checkbox$enabled, _sorting$defaultDirec;
  // =============== PROPS
  const {
      className,
      columns = [],
      checked = 'none',
      sorting = {
        defaultDirection: 'asc'
      },
      checkbox,
      tableRowProps,
      divider = true,
      dividerProps,
      stickyHeader,
      columnBorder,
      backgroundColor = '#eeeeee',
      onSort,
      onCheckAll
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$9);

  // =============== VARIABLES
  const enableCheckbox = (_checkbox$enabled = checkbox == null ? void 0 : checkbox.enabled) != null ? _checkbox$enabled : false;
  const defaultOrderBy = sorting == null ? void 0 : sorting.defaultOrder;
  const defaultOrderDirection = (_sorting$defaultDirec = sorting == null ? void 0 : sorting.defaultDirection) != null ? _sorting$defaultDirec : 'asc';
  // restructure header based on its settings
  const header = useMemo(() => {
    // recompose header array based on its settings
    const list = columns.map(item => {
      var _item$group;
      // if there is no group setting
      if (!item.group) return {
        content: item,
        span: 1
      };
      // group key when there is column being found based on key
      const groupKey = (_item$group = item.group) == null ? void 0 : _item$group.key;
      const groupItems = columns.filter(subItem => subItem.group && subItem.group.key === groupKey);
      return {
        group: item.group,
        content: groupItems,
        span: groupItems.length
      };
    });
    return list.filter((item, index, self) => {
      const foundIndex = self.findIndex(t => {
        return t.group && item.group && t.group.key === item.group.key;
      });
      return index === foundIndex || !item.group;
    });
  }, [columns]);
  const hasGroup = useMemo(() => {
    const group = header.filter(col => !!(col != null && col.group));
    return !isEmpty(group);
  }, [header]);
  const isColumnBorderDefault = columnBorder === 'default';
  const columnBorderStyle = isColumnBorderDefault || hasGroup ? 'default' : 'preset';

  // =============== STATE
  const [orderByState, setOrderByState] = useState(defaultOrderBy);
  const [orderDirectionState, setOrderDirectionState] = useState(defaultOrderDirection);

  // =============== EFFECTS
  useEffect(() => {
    return setOrderByState(defaultOrderBy);
  }, [defaultOrderBy]);
  useEffect(() => {
    return setOrderDirectionState(defaultOrderDirection);
  }, [defaultOrderDirection]);

  // =============== EVENTS
  const onHandleSortClick = key => {
    return e => {
      const isCurrent = key === orderByState;
      const isAsc = isCurrent && orderDirectionState === 'asc';
      const nextDirection = isAsc ? 'desc' : 'asc';
      setOrderByState(key);
      setOrderDirectionState(nextDirection);
      onSort == null ? void 0 : onSort(key, nextDirection, e);
    };
  };

  // =============== RENDER FUNCTIONS
  const renderColumnContent = column => {
    const {
      key,
      title,
      sortable,
      uppercase = true
    } = column;
    const isStringTitle = typeof title === 'string';
    const columnTitle = isStringTitle && uppercase ? title.toUpperCase() : title;
    const isCurrent = orderByState === key;
    if (!sortable) {
      return columnTitle;
    }
    return jsxs(TableSortLabel, {
      active: isCurrent,
      direction: isCurrent ? orderDirectionState : 'asc',
      onClick: onHandleSortClick(key),
      children: [columnTitle, isCurrent && jsx$1(Box, {
        component: "span",
        sx: visuallyHidden$1,
        children: orderDirectionState === 'desc' ? 'sorted descending' : 'sorted ascending'
      })]
    });
  };
  const renderColumn = (column, colSpan, rowSpan, groupType) => {
    var _column$headerColumnP, _ref, _column$alignTitle;
    const {
      key,
      sticky
    } = column;
    const isCurrent = orderByState === key;
    return jsx$1(StyledTableCell, Object.assign({
      className: cn({
        'table-head-group': groupType === 'group',
        'table-head-group-item': groupType === 'item'
      })
    }, column.headerColumnProps, {
      sx: Object.assign({
        width: column.width,
        minWidth: column.minWidth,
        fontSize: '0.8rem',
        fontWeight: '600 !important',
        whiteSpace: 'nowrap',
        zIndex: sticky ? 3 : undefined
      }, (_column$headerColumnP = column.headerColumnProps) == null ? void 0 : _column$headerColumnP.sx),
      align: (_ref = (_column$alignTitle = column.alignTitle) != null ? _column$alignTitle : column.align) != null ? _ref : 'left',
      valign: 'middle',
      sortDirection: isCurrent ? defaultOrderDirection : false,
      sticky: sticky,
      colSpan: colSpan,
      rowSpan: rowSpan,
      children: renderColumnContent(column)
    }), key);
  };

  // =============== VIEWS
  if (columns.length === 0) return null;
  return jsxs(StyledTableHead, Object.assign({
    className: cn('table-head', className),
    divider: divider,
    options: dividerProps,
    stickyHeader: stickyHeader,
    columnBorder: columnBorderStyle,
    backgroundColor: backgroundColor
  }, restProps, {
    children: [jsxs(MuiTableRow, Object.assign({
      className: cn('table-head-row', tableRowProps == null ? void 0 : tableRowProps.className)
    }, tableRowProps, {
      children: [enableCheckbox && jsx$1(MuiTableCell, {
        padding: "checkbox",
        align: "center",
        valign: "middle",
        rowSpan: hasGroup ? 2 : undefined,
        children: jsx$1(Checkbox, {
          color: "primary",
          indeterminate: checked === 'partial',
          checked: checked === 'all',
          onChange: event => {
            const checkedState = event.target.checked;
            onCheckAll == null ? void 0 : onCheckAll(checkedState, checked);
          },
          inputProps: {
            'aria-label': 'Select all'
          }
        })
      }), header.map(col => {
        if (col != null && col.group) {
          return renderColumn(col.group, col.span, undefined, 'group');
        }
        if (!hasGroup) {
          return renderColumn(col.content);
        }
        return renderColumn(col.content, 1, 2);
      })]
    })), hasGroup && jsx$1(MuiTableRow, Object.assign({
      className: cn('table-head-row grouping-column', tableRowProps == null ? void 0 : tableRowProps.className)
    }, tableRowProps, {
      children: header.map(col => {
        var _col$content;
        if (!(col != null && col.group)) return null;
        return col == null || (_col$content = col.content) == null ? void 0 : _col$content.map(column => {
          return renderColumn(column, undefined, undefined, 'item');
        });
      })
    }))]
  }));
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$4;
var toString$1 = toString$3;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var global$1 = global$d;
var fails = fails$e;
var uncurryThis = functionUncurryThis;
var toString = toString$3;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = global$1.parseInt;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $ = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

const _excluded$8 = ["className", "data", "page", "total", "pageSize", "pageSizeOptions", "onPageChange", "onPageSizeChange"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TablePagination = props => {
  const {
      className,
      data = [],
      page = 0,
      total,
      pageSize = 10,
      pageSizeOptions = [10, 25, 50, 75, 100],
      onPageChange,
      onPageSizeChange
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$8);

  // =============== STATE
  const [pageState, setPageState] = useState(0);
  const [rowsPerPageState, setRowsPerPageState] = useState(pageSize);

  // =============== VARIABLES
  const intendPage = pageState - 1;

  // =============== API
  useEffect(() => {
    setPageState(page);
  }, [page]);

  // =============== EVENTS
  const onHandlePageChange = (_event, newPage) => {
    setPageState(newPage);
    onPageChange == null ? void 0 : onPageChange(newPage + 1);
  };
  const onHandlePageSizeChange = event => {
    const perPage = parseInt(event.target.value, 10);
    setPageState(0);
    onPageChange == null ? void 0 : onPageChange(0);
    setRowsPerPageState(perPage);
    onPageSizeChange == null ? void 0 : onPageSizeChange(perPage);
  };

  // =============== VIEWS
  return jsx$1(MUITablePagination, Object.assign({
    className: cn('table-pagination', className),
    component: "div"
  }, restProps, {
    count: total != null ? total : data.length,
    page: intendPage < 0 ? 0 : intendPage,
    rowsPerPage: rowsPerPageState,
    rowsPerPageOptions: pageSizeOptions,
    onPageChange: onHandlePageChange,
    onRowsPerPageChange: onHandlePageSizeChange
  }));
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledTableRow = styled(MuiTableRow, {
  shouldForwardProp: prop => !['clickable'].includes(prop)
})(props => {
  const {
    clickable = false,
    theme
  } = props;
  return {
    cursor: clickable ? 'pointer' : undefined,
    '&.Mui-selected td': {
      background: `${theme.palette.action.selected} !important`
    }
  };
});

const _excluded$7 = ["className", "data", "checkbox", "columns", "checked", "expandable", "expandableProps", "onCheck", "onClick", "onExpand", "renderExpandedView"];
const TableRow = props => {
  var _checkbox$enabled;
  const {
      className,
      data,
      checkbox,
      columns = [],
      checked = false,
      expandable = false,
      expandableProps,
      onCheck,
      onClick,
      onExpand,
      renderExpandedView
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$7);

  // =============== VARIABLES
  const clickable = !!onClick || expandable;
  const enableCheckbox = (_checkbox$enabled = checkbox == null ? void 0 : checkbox.enabled) != null ? _checkbox$enabled : false;

  // =============== STATE
  const [expanded, setExpanded] = useState(false);

  // =============== EVENTS
  const onClickRow = event => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick(data, event);
    if (!expandable) return;
    setExpanded(!expanded);
  };
  const onHandleCheckbox = event => {
    event.stopPropagation();
    if (!enableCheckbox) return;
    const checkedState = event.target.checked;
    let record = data;
    if (checkbox != null && checkbox.dataIndex) {
      record = data == null ? void 0 : data[checkbox.dataIndex];
    }
    onCheck == null ? void 0 : onCheck(checkedState, record, {
      data
    });
  };

  // =============== HELPERS
  const renderColumnData = (column, index) => {
    if (!data) return null;
    const {
      dataIndex,
      render
    } = column;
    const result = dataIndex ? data[dataIndex] : data;
    if (render) return render(result, data, index);
    if (typeof result === 'object') return JSON.stringify(result);
    return result;
  };

  // =============== VIEWS
  return jsxs(Fragment, {
    children: [jsxs(StyledTableRow, Object.assign({
      className: cn('table-row', className),
      selected: checked,
      clickable: clickable,
      onClick: onClickRow
    }, restProps, {
      children: [enableCheckbox && jsx$1(MuiTableCell, {
        padding: "checkbox",
        align: "center",
        children: jsx$1(Checkbox, {
          color: "primary",
          checked: checked,
          onClick: e => e.stopPropagation(),
          onChange: onHandleCheckbox
        })
      }), columns.map((column, index) => {
        var _column$align, _column$dataColumnPro;
        if (column.sticky && column.group) {
          console.log('Sticky column is not allowing with group');
        }
        return jsx$1(StyledTableCell, Object.assign({
          align: (_column$align = column.align) != null ? _column$align : 'left'
        }, column.dataColumnProps, {
          sx: Object.assign({
            width: column.width,
            minWidth: column.minWidth
          }, (_column$dataColumnPro = column.dataColumnProps) == null ? void 0 : _column$dataColumnPro.sx),
          sticky: !column.group ? column.sticky : false,
          children: jsx$1(Fragment, {
            children: renderColumnData(column, index)
          })
        }), `${column.key}-${index}`);
      })]
    })), expandable && jsx$1(MuiTableRow, Object.assign({
      className: "table-row-expand"
    }, restProps, {
      children: jsx$1(MuiTableCell, Object.assign({
        padding: "none",
        colSpan: columns.length + (enableCheckbox ? 1 : 0)
      }, expandableProps, {
        children: jsx$1(Collapse, {
          timeout: "auto",
          in: expanded,
          unmountOnExit: true,
          addEndListener: () => onExpand == null ? void 0 : onExpand(data, expanded),
          children: renderExpandedView == null ? void 0 : renderExpandedView(data, expanded)
        })
      }))
    }))]
  });
};

var pkg = {
	name: "@emotion/react",
	version: "11.11.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	exports: {
		".": {
			module: {
				worker: "./dist/emotion-react.worker.esm.js",
				browser: "./dist/emotion-react.browser.esm.js",
				"default": "./dist/emotion-react.esm.js"
			},
			"import": "./dist/emotion-react.cjs.mjs",
			"default": "./dist/emotion-react.cjs.js"
		},
		"./jsx-runtime": {
			module: {
				worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
				browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
				"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
			},
			"import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
			"default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
		},
		"./_isolated-hnrs": {
			module: {
				worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
				browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
				"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
			},
			"import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
			"default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
		},
		"./jsx-dev-runtime": {
			module: {
				worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
				browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
				"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
			},
			"import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
			"default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
		},
		"./package.json": "./package.json",
		"./types/css-prop": "./types/css-prop.d.ts",
		"./macro": {
			types: {
				"import": "./macro.d.mts",
				"default": "./macro.d.ts"
			},
			"default": "./macro.js"
		}
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.*"
	],
	sideEffects: false,
	author: "Emotion Contributors",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.18.3",
		"@emotion/babel-plugin": "^11.11.0",
		"@emotion/cache": "^11.11.0",
		"@emotion/serialize": "^1.1.2",
		"@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
		"@emotion/utils": "^1.2.1",
		"@emotion/weak-memoize": "^0.3.1",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@definitelytyped/dtslint": "0.0.112",
		"@emotion/css": "11.11.0",
		"@emotion/css-prettifier": "1.1.3",
		"@emotion/server": "11.11.0",
		"@emotion/styled": "11.11.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1",
		typescript: "^4.5.5"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact",
		exports: {
			envConditions: [
				"browser",
				"worker"
			],
			extra: {
				"./types/css-prop": "./types/css-prop.d.ts",
				"./macro": {
					types: {
						"import": "./macro.d.mts",
						"default": "./macro.d.ts"
					},
					"default": "./macro.js"
				}
			}
		}
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return React.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {
  if (process.env.NODE_ENV !== 'production' && !warnedAboutCssPropForGlobal && ( // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  props.className || props.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React.useContext(ThemeContext));

  if (!isBrowser$1) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/React.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (process.env.NODE_ENV !== 'production') {
  Global.displayName = 'EmotionGlobal';
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (process.env.NODE_ENV !== 'production' && arg.styles !== undefined && arg.name !== undefined) {
              console.error('You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n' + '`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.');
            }

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$1 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$1) {
      return rules;
    }
  });

  if (!isBrowser$1 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && process.env.NODE_ENV !== 'production') {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

if (process.env.NODE_ENV !== 'production') {
  ClassNames.displayName = 'EmotionClassNames';
}

if (process.env.NODE_ENV !== 'production') {
  var isBrowser = typeof document !== 'undefined'; // #1727, #2905 for some reason Jest and Vitest evaluate modules twice if some consuming module gets mocked

  var isTestEnv = typeof jest !== 'undefined' || typeof vi !== 'undefined';

  if (isBrowser && !isTestEnv) {
    // globalThis has wide browser support - https://caniuse.com/?search=globalThis, Node.js 12 and later
    var globalContext = // $FlowIgnore
    typeof globalThis !== 'undefined' ? globalThis // eslint-disable-line no-undef
    : isBrowser ? window : global;
    var globalKey = "__EMOTION_REACT_" + pkg.version.split('.')[0] + "__";

    if (globalContext[globalKey]) {
      console.warn('You are loading @emotion/react when it is already loaded. Running ' + 'multiple instances may cause problems. This can happen if multiple ' + 'versions are used, or if multiple builds of the same version are ' + 'used.');
    }

    globalContext[globalKey] = true;
  }
}

const _excluded$6 = ["data", "columns", "checked", "total", "loading", "bordered", "striped", "loadingRows", "pagination", "expandable", "enableTableHeadDivider", "stickyHeader", "page", "pageSize", "pageSizeOptions", "checkbox", "children", "topView", "emptyView", "noDataView", "loadingView", "footerView", "tableContainerProps", "tableHeadProps", "tableBodyProps", "tableRowProps", "tableFooterProps", "tablePaginationProps", "onCheck", "onRowClick", "onRowExpand", "onColumnSort", "onPageChange", "onPageSizeChange", "renderExpandedView", "renderPagination"];
const Table = props => {
  var _checkbox$enabled, _renderPagination;
  // =============== PROPS
  const {
      data = [],
      columns = [],
      checked = [],
      total,
      loading = false,
      bordered = true,
      striped = false,
      loadingRows = 10,
      pagination = true,
      expandable = false,
      enableTableHeadDivider = true,
      stickyHeader = false,
      page,
      pageSize,
      pageSizeOptions,
      checkbox,
      children,
      // custom view
      topView,
      emptyView,
      noDataView,
      loadingView,
      footerView,
      // view props
      tableContainerProps,
      tableHeadProps,
      tableBodyProps,
      tableRowProps,
      tableFooterProps,
      tablePaginationProps,
      // function
      onCheck,
      onRowClick,
      onRowExpand,
      onColumnSort,
      onPageChange,
      onPageSizeChange,
      renderExpandedView,
      renderPagination
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$6);

  // =============== STATE
  const [checkedState, setCheckedState] = useState(checked);

  // =============== VARIABLES
  const hasData = (data == null ? void 0 : data.length) > 0;
  const hasDefinedTotal = !isNil(total);
  const hasChecked = (checkedState == null ? void 0 : checkedState.length) > 0;
  const enableCheckbox = (_checkbox$enabled = checkbox == null ? void 0 : checkbox.enabled) != null ? _checkbox$enabled : false;
  const columnLength = enableCheckbox ? columns.length + 1 : columns.length;
  const hasStickySet = !isNil(stickyHeader);
  const isStickyEnabled = hasStickySet && (typeof stickyHeader === 'boolean' && stickyHeader || typeof stickyHeader === 'object');

  // ================== HELPERS
  const getCheckedStatus = () => {
    if (hasDefinedTotal && hasChecked) {
      if (checkedState.length >= total) return 'all';
      return 'partial';
    }
    if (hasChecked) {
      if (data.length === checkedState.length) return 'all';
      return 'partial';
    }
    return 'none';
  };

  // =============== HELPERS
  const triggerCheckboxUpdate = val => {
    setCheckedState(val);
    onCheck == null ? void 0 : onCheck(val);
  };
  const extractCheckedValue = val => {
    if (!(checkbox != null && checkbox.enabled)) return null;
    if (typeof val === 'number' || typeof val === 'string') {
      return val;
    }
    if (!checkbox.dataIndex) {
      return val;
    }
    return val == null ? void 0 : val[checkbox.dataIndex];
  };

  // =============== EFFECTS
  useDeepCompareEffect(() => {
    triggerCheckboxUpdate(checked);
  }, [checked]);

  // =============== EVENTS
  const onHandleCheckAll = (checked, state) => {
    // stop acton if checkbox wasn't enabled
    if (!(checkbox != null && checkbox.enabled)) return;
    if (!checked) {
      triggerCheckboxUpdate([]);
      return;
    }
    const indexes = data.reduce((r, e) => {
      const value = extractCheckedValue(e);
      if (value) r.push(value);
      return r;
    }, []);

    // if checkbox in checked state
    if (state === 'partial') {
      if (indexes.some(e => e === checkedState)) {
        triggerCheckboxUpdate([]);
        return;
      }
    }
    triggerCheckboxUpdate(uniq([...checkedState, ...indexes]));
  };
  const onHandleCheckItem = (checked, record) => {
    const value = record;
    if (!value) return;
    if (checked) {
      triggerCheckboxUpdate([...checkedState, value]);
    } else {
      triggerCheckboxUpdate(checkedState.filter(e => e !== value));
    }
  };

  // =============== RENDER FUNCTIONS
  const renderMuiTableBodyContent = () => {
    if (loading) {
      if (loadingView) return loadingView;
      return [...Array(loadingRows)].map((e, i) => jsxs(MuiTableRow, {
        className: "table-row-loading",
        children: [enableCheckbox && jsx$1(MuiTableCell, {
          colSpan: 1
        }), columns.map(c => {
          var _c$dataColumnProps;
          return jsx$1(MuiTableCell, Object.assign({
            align: "center"
          }, c.dataColumnProps, {
            sx: Object.assign({
              width: c.width
            }, (_c$dataColumnProps = c.dataColumnProps) == null ? void 0 : _c$dataColumnProps.sx),
            children: jsx$1(Skeleton, {
              height: 30
            })
          }), c.key);
        })]
      }, i));
    }
    if (!hasData) {
      return jsx$1(MuiTableRow, {
        className: "table-row-empty",
        children: jsx$1(MuiTableCell, {
          colSpan: columnLength,
          align: "center",
          padding: "none",
          children: emptyView != null ? emptyView : jsx$1(Typography, {
            py: 12,
            height: '100%',
            children: noDataView != null ? noDataView : 'No Data'
          })
        })
      });
    }
    return data.map((e, i) => {
      const checkIndex = extractCheckedValue(e);
      const isChecked = checkIndex ? checkedState.includes(checkIndex) : false;
      return jsx(TableRow, Object.assign({}, tableRowProps, {
        key: i,
        data: e,
        columns: columns,
        checkbox: checkbox,
        checked: isChecked,
        expandable: expandable,
        onCheck: onHandleCheckItem,
        onClick: onRowClick ? (r, e) => onRowClick(r, e, i) : undefined,
        onExpand: onRowExpand ? (r, e) => onRowExpand(r, e, i) : undefined,
        renderExpandedView: renderExpandedView ? (record, expanded) => renderExpandedView(record, expanded, i) : undefined
      }));
    });
  };

  // =============== VIEWS
  return jsxs("div", {
    className: "table-main-wrapper",
    children: [topView && jsx$1("div", {
      className: "table-top-container",
      children: topView
    }), jsx$1(MuiTableContainer, Object.assign({}, tableContainerProps, {
      sx: Object.assign({
        position: 'relative'
      }, isStickyEnabled ? {
        maxHeight: typeof stickyHeader !== 'boolean' ? stickyHeader.tableMaxHeight || 1000 : 1000
      } : {}, tableContainerProps == null ? void 0 : tableContainerProps.sx),
      children: jsxs(StyledTable, Object.assign({
        sx: Object.assign({
          opacity: loading ? 0.4 : 1
        }, restProps.sx),
        striped: striped,
        bordered: bordered
      }, restProps, {
        children: [jsx$1(TableHead, Object.assign({
          columns: columns,
          checkbox: checkbox,
          stickyHeader: isStickyEnabled,
          divider: enableTableHeadDivider,
          onSort: onColumnSort,
          checked: getCheckedStatus(),
          onCheckAll: onHandleCheckAll
        }, tableHeadProps)), jsxs(MuiTableBody, Object.assign({}, tableBodyProps, {
          children: [renderMuiTableBodyContent(), children]
        })), footerView && jsx$1(MuiTableFooter, Object.assign({}, tableFooterProps, {
          children: footerView
        }))]
      }))
    })), pagination && jsx$1(StyledPaginationWrapper, {
      className: "table-pagination-wrapper",
      children: (_renderPagination = renderPagination == null ? void 0 : renderPagination({
        page,
        total,
        data,
        pageSize,
        pageSizeOptions,
        onPageChange,
        onPageSizeChange
      })) != null ? _renderPagination : jsx$1(TablePagination, Object.assign({
        page: page,
        total: total,
        data: data,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        onPageChange: onPageChange,
        onPageSizeChange: onPageSizeChange
      }, tablePaginationProps))
    })]
  });
};

const _excluded$5 = ["items", "size", "variant", "icon", "tooltip", "onChange"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TableSettingsOptions = /*#__PURE__*/memo(props => {
  const {
      items,
      size = 'medium',
      variant = 'text',
      icon,
      tooltip,
      onChange
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$5);

  // =============== VIEW
  return jsx$1(ButtonDropdown, Object.assign({
    type: "icon",
    size: size,
    variant: variant,
    tooltip: tooltip,
    items: items
  }, restProps, {
    onItemClick: e => onChange == null ? void 0 : onChange(e),
    children: icon != null ? icon : jsx$1(SettingsOutlinedIcon, {})
  }));
});

const _excluded$4 = ["className", "size", "variant", "icon", "total", "text", "items", "tooltip", "onChange"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TableSelectedBulkOptions = /*#__PURE__*/memo(props => {
  const {
      className,
      size = 'medium',
      variant = 'text',
      icon,
      total = 0,
      text = '{count} Item(s) Selected',
      items = [{
        key: 'delete',
        title: 'Delete'
      }, {
        key: 'export',
        title: 'Export'
      }],
      tooltip,
      onChange
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$4);

  // =============== VIEW
  return jsx$1(ButtonDropdown, Object.assign({
    className: className,
    type: "button",
    size: size,
    variant: variant,
    tooltip: tooltip,
    items: items
  }, restProps, {
    onItemClick: e => onChange == null ? void 0 : onChange(e),
    render: ({
      open
    }) => {
      var _icon$collapse, _icon$expand;
      return jsxs(Fragment, {
        children: [replace$3(text, '{count}', `${total}`), ' ', open && ((_icon$collapse = icon == null ? void 0 : icon.collapse) != null ? _icon$collapse : jsx$1(ArrowDropUpOutlinedIcon, {})), !open && ((_icon$expand = icon == null ? void 0 : icon.expand) != null ? _icon$expand : jsx$1(ArrowDropDownOutlinedIcon, {}))]
      });
    }
  }));
});

const _excluded$3 = ["items", "size", "variant", "icon", "text", "tooltip", "onChange"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TableSettingsDensityOptions = /*#__PURE__*/memo(props => {
  var _text$default, _text$small, _text$medium;
  const {
      items,
      size = 'medium',
      variant = 'text',
      icon,
      text = {
        default: 'Default',
        small: 'Small',
        medium: 'Medium'
      },
      tooltip,
      onChange
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$3);

  // =============== VIEW
  return jsx$1(ButtonDropdown, Object.assign({
    type: "icon",
    size: size,
    variant: variant,
    tooltip: tooltip,
    items: items != null ? items : [{
      key: 'middle',
      title: (_text$default = text == null ? void 0 : text.default) != null ? _text$default : 'Default'
    }, {
      key: 'small',
      title: (_text$small = text == null ? void 0 : text.small) != null ? _text$small : 'Small'
    }, {
      key: 'middle',
      title: (_text$medium = text == null ? void 0 : text.medium) != null ? _text$medium : 'Medium'
    }]
  }, restProps, {
    onItemClick: e => onChange == null ? void 0 : onChange(e),
    children: icon != null ? icon : jsx$1(TableRowsOutlinedIcon, {})
  }));
});

const _excluded$2 = ["size", "icon", "variant", "selected", "text", "tooltip", "onChange"];
/**
 * ===========================
 * MAIN
 * ===========================
 */
const TableSettingsSortingOptions = /*#__PURE__*/memo(props => {
  var _text$default, _text$asc, _text$desc;
  const {
      size = 'medium',
      icon,
      variant = 'text',
      selected = 'DEFAULT',
      text = {
        default: 'Default',
        asc: 'Ascending',
        desc: 'Descending'
      },
      tooltip,
      onChange
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$2);

  // =============== VIEW
  return jsx$1(ButtonDropdown, Object.assign({
    type: "icon",
    size: size,
    variant: variant,
    tooltip: tooltip,
    selected: selected,
    items: [{
      key: 'DEFAULT',
      title: (_text$default = text == null ? void 0 : text.default) != null ? _text$default : 'Default'
    }, {
      key: 'ASC',
      title: (_text$asc = text == null ? void 0 : text.asc) != null ? _text$asc : 'Ascending'
    }, {
      key: 'DESC',
      title: (_text$desc = text == null ? void 0 : text.desc) != null ? _text$desc : 'Descending'
    }]
  }, restProps, {
    onItemClick: e => onChange == null ? void 0 : onChange(e),
    children: icon != null ? icon : jsx$1(SortOutlinedIcon, {})
  }));
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const TabLabel = /*#__PURE__*/memo(props => {
  const {
    label,
    count,
    chipColor = 'default',
    chipProps
  } = props;

  // =============== VARIABLES
  const hasCount = !isNil(count);
  const isElement = /*#__PURE__*/isValidElement(count);

  // =============== VIEWS
  return jsxs(Fragment, {
    children: [label, !hasCount ? null : isElement ? count : jsx$1(Chip, Object.assign({
      sx: {
        marginLeft: 0.5
      },
      color: chipColor,
      label: count
    }, chipProps))]
  });
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledTab = styled(Tab, {
  shouldForwardProp: prop => !['unstyled'].includes(prop)
})(({
  theme,
  unstyled
}) => {
  if (unstyled) return {};
  return {
    '.MuiChip-root': {
      height: 24,
      '.MuiChip-label': {
        paddingLeft: 8,
        paddingRight: 8
      }
    }
  };
});

const _excluded$1 = ["value", "items", "className", "variant", "orientation", "iconPosition", "scrollButtons", "unstyled", "tabsProps", "tabLabelProps", "onChange", "renderContent"],
  _excluded2 = ["key", "enabled", "content", "label", "count", "countColor"];
const TabView = /*#__PURE__*/memo(props => {
  const {
      value,
      items = [],
      className,
      variant = 'scrollable',
      orientation = 'horizontal',
      iconPosition = 'start',
      scrollButtons = 'auto',
      unstyled,
      tabsProps,
      tabLabelProps,
      onChange,
      renderContent
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded$1);

  // =============== STATE
  const [valueState, setValueState] = useState();

  // =============== EFFECTS
  useEffect(() => setValueState(value), [value]);

  // =============== VARIABLES
  const hasContent = useMemo(() => {
    return items.some(e => !!e.content) || !!renderContent;
  }, [items, renderContent]);

  // =============== HOOKS
  if (items.length === 0) return null;
  return jsxs(Box, {
    className: "tabview-wrapper",
    children: [jsx$1(Tabs, Object.assign({
      className: cn('tabview-tabs', className),
      value: valueState || false,
      variant: variant,
      orientation: orientation,
      scrollButtons: scrollButtons
    }, restProps, tabsProps, {
      onChange: (e, item) => {
        e.stopPropagation();
        e.preventDefault();
        setValueState(item);
        onChange == null ? void 0 : onChange(item);
      },
      children: items.map(e => {
        const {
            key,
            enabled = true,
            label,
            count,
            countColor
          } = e,
          restItemProps = _objectWithoutPropertiesLoose(e, _excluded2);
        if (!enabled) return null;
        return jsx$1(StyledTab, Object.assign({
          id: `tabview-tabs-item-${key}`,
          className: "tabview-tabs-item",
          value: key,
          unstyled: unstyled,
          iconPosition: iconPosition,
          label: jsx$1(TabLabel, Object.assign({
            label: label,
            count: count,
            chipColor: countColor
          }, tabLabelProps))
        }, restItemProps), key);
      })
    })), valueState && hasContent && jsx$1(Box, {
      className: "tabview-content-wrapper",
      children: renderContent ? jsx$1(Box, {
        className: "tabview-content-item",
        children: renderContent(valueState)
      }) : items.map(e => {
        const {
          key,
          enabled = true,
          content
        } = e;
        if (!enabled || !content) return null;
        return jsx$1(Box, {
          className: cn('tabview-content-item', key),
          children: typeof content === 'function' ? content() : content
        }, key);
      })
    })]
  });
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledWrapper$4 = styled(Box, {
  shouldForwardProp: prop => !['unstyled', 'spacingMultiplier', 'hasActions'].includes(prop)
})(({
  theme,
  unstyled,
  spacingMultiplier,
  hasActions
}) => {
  if (unstyled) return {};
  const hasMultiplier = !isNil(spacingMultiplier);
  return {
    '.crud-filter-title': {
      marginBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2)
    },
    '.crud-filter-content': {
      marginBottom: hasActions ? theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2) : undefined
    },
    '.crud-filter-actions': {}
  };
});

const CrudFilterView = /*#__PURE__*/memo(props => {
  const {
    unstyled,
    className,
    title,
    actions,
    spacingMultiplier,
    children
  } = props;

  // =============== VARIABLES
  const hasActions = typeof actions === 'function' || typeof actions === 'object' && actions.length > 0;

  // =============== VIEW
  if (!title && !children && !actions) {
    return null;
  }
  return jsxs(StyledWrapper$4, {
    unstyled: unstyled,
    spacingMultiplier: spacingMultiplier,
    hasActions: hasActions,
    className: cn('crud-filter-wrapper', className),
    children: [title && jsx$1(Typography, {
      className: "crud-filter-title",
      variant: "subtitle1",
      fontWeight: "700",
      children: title
    }), !!children && jsx$1(Box, {
      className: "crud-filter-content",
      children: children
    }), typeof actions === 'function' && jsx$1(Box, {
      className: "crud-filter-actions",
      children: actions()
    }), typeof actions === 'object' && actions.length > 0 && jsx$1(Box, {
      className: "crud-filter-actions",
      children: jsx$1(RenderFlexView, {
        items: [actions]
      })
    })]
  });
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledWrapper$3 = styled(Box, {
  shouldForwardProp: prop => !['unstyled', 'spacingMultiplier'].includes(prop)
})(({
  theme,
  unstyled,
  spacingMultiplier
}) => {
  if (unstyled) return {};
  const hasMultiplier = !isNil(spacingMultiplier);
  return {
    '.crud-page-header-breadcrumbs': {
      marginBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2)
    }
  };
});

const _excluded = ["unstyled", "className", "title", "items", "actions", "backPath", "backIcon", "titleProps", "wrapperProps", "backPathProps", "breadcrumbProps", "spacingMultiplier"];
const CrudPageHeaderView = /*#__PURE__*/memo(props => {
  const {
      unstyled,
      className,
      title,
      items = [],
      actions = [],
      backPath,
      backIcon,
      titleProps,
      wrapperProps,
      backPathProps,
      breadcrumbProps,
      spacingMultiplier
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);

  // =============== VARIABLES
  const hasActions = actions.length > 0;
  const hasBreadcrumbs = items.length > 0;

  // =============== VIEW
  if (!backPath && !hasActions && !hasBreadcrumbs && !title) {
    return null;
  }
  return jsxs(StyledWrapper$3, Object.assign({
    unstyled: unstyled,
    className: cn('crud-page-header-wrapper', className),
    spacingMultiplier: spacingMultiplier
  }, wrapperProps, {
    children: [hasBreadcrumbs && jsx$1(BreadcrumbView, Object.assign({
      className: "crud-page-header-breadcrumbs",
      items: items
    }, breadcrumbProps)), jsxs(Grid, {
      container: true,
      alignItems: "center",
      justifyContent: "start",
      className: "crud-page-header-content",
      children: [jsx$1(Grid, {
        item: true,
        className: "crud-page-header-title",
        children: jsxs(Stack, Object.assign({
          direction: "row",
          justifyContent: "start",
          alignItems: "center",
          spacing: 1
        }, restProps, {
          children: [backPath && jsx$1(Link, Object.assign({
            className: "crud-page-header-title-back",
            sx: {
              display: 'flex',
              alignItems: 'center'
            },
            component: NextLink,
            href: backPath
          }, backPathProps, {
            children: backIcon != null ? backIcon : jsx$1(ChevronLeftIcon, {
              color: "inherit"
            })
          })), title && jsx$1(Typography, Object.assign({
            className: "crud-page-header-title-text",
            variant: "h5"
          }, titleProps, {
            children: title
          }))]
        }))
      }), hasActions && jsxs(Fragment, {
        children: [jsx$1(Grid, {
          item: true,
          flex: "auto"
        }), jsx$1(Grid, {
          item: true,
          className: "crud-page-header-actions",
          children: jsx$1(RenderNodeView, {
            direction: "row",
            spacing: 2,
            items: actions
          })
        })]
      })]
    })]
  }));
});

/**
 * ===========================
 * MAIN
 * ===========================
 */ // check is action enabled
const isActionEnable = (action, checking = []) => {
  return includes(checking || [], action);
};

// get tooltip text
const getTooltipText = (key, options) => {
  var _options$createText;
  const tooltip = options == null ? void 0 : options.tooltip;
  const enabled = isNil(tooltip) ? true : !!tooltip;

  // default tooltip mapping
  const mapping = {
    expand: 'Expand',
    refresh: 'Refresh',
    density: 'Density',
    sorting: 'Sort',
    settings: 'Settings',
    create: (_options$createText = options == null ? void 0 : options.createText) != null ? _options$createText : 'Create',
    filter: 'Filter'
  };
  if (!tooltip || typeof tooltip === 'boolean') {
    var _mapping$key;
    return {
      enabled,
      title: (_mapping$key = mapping[key]) != null ? _mapping$key : capitalize(key)
    };
  }
  if (typeof tooltip === 'string') {
    return {
      enabled,
      title: tooltip
    };
  }
  return Object.assign({
    enabled
  }, tooltip);
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const defaultText$2 = {
  createText: 'Create',
  expandText: 'Expand',
  collapseText: 'Collapse',
  sorting: {
    default: 'Default',
    asc: 'Ascending',
    desc: 'Descending'
  },
  density: {
    default: 'Default',
    small: 'Small',
    medium: 'Medium'
  }
};

/**
 * ===========================
 * MAIN
 * ===========================
 */ // hooks to get header actions
const useHeaderActionSettings = props => {
  var _text$createText, _text$collapseText, _text$expandText;
  const {
    text,
    sortingType,
    expanded,
    headerExpandView,
    headerActions = [],
    headerActionSize = 'small',
    onTriggerCreate,
    onTriggerRefresh,
    onTriggerSettings,
    onTriggerSorting,
    onTriggerDensity,
    onTriggerExpand
  } = props;

  // =============== VARIABLES
  const createText = (_text$createText = text == null ? void 0 : text.createText) != null ? _text$createText : defaultText$2 == null ? void 0 : defaultText$2.createText;
  const collapseText = (_text$collapseText = text == null ? void 0 : text.collapseText) != null ? _text$collapseText : defaultText$2 == null ? void 0 : defaultText$2.collapseText;
  const expandText = (_text$expandText = text == null ? void 0 : text.expandText) != null ? _text$expandText : defaultText$2 == null ? void 0 : defaultText$2.expandText;

  // =============== VIEWS
  const views = useMemo(() => {
    const viewList = [];

    // ----- loop of actions
    forEach(headerActions, (field, i) => {
      var _field$enabled;
      const type = field.action;
      const tooltip = field.tooltip;
      const enabled = (_field$enabled = field.enabled) != null ? _field$enabled : true;

      // ----- create button
      if (type === 'create' && enabled) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            var _field$node;
            const tooltips = getTooltipText('create', {
              tooltip,
              createText
            });
            return jsx$1(TooltipView, Object.assign({}, tooltips, {
              children: jsx$1(Button, Object.assign({
                size: headerActionSize,
                variant: "outlined",
                onClick: onTriggerCreate
              }, field.props, {
                children: (_field$node = field == null ? void 0 : field.node) != null ? _field$node : createText
              }))
            }));
          }
        });
      }

      // ----- refresh
      if (type === 'refresh' && enabled) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            var _field$icon;
            const tooltips = getTooltipText('refresh', {
              tooltip
            });
            return jsx$1(TooltipView, Object.assign({}, tooltips, {
              children: jsx$1(IconButton, Object.assign({
                size: headerActionSize,
                onClick: onTriggerRefresh
              }, field.props, {
                children: (_field$icon = field == null ? void 0 : field.icon) != null ? _field$icon : jsx$1(CachedIcon, {})
              }))
            }));
          }
        });
      }

      // ----- settings
      if (type === 'settings' && enabled) {
        const tooltips = getTooltipText('settings', {
          tooltip
        });
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            return jsx$1(TableSettingsOptions, {
              size: headerActionSize,
              icon: field == null ? void 0 : field.icon,
              items: field.items,
              tooltip: omit(tooltips, ['enabled']),
              buttonProps: field.props,
              onChange: onTriggerSettings
            });
          }
        });
      }

      // ----- sorting
      if (type === 'sorting' && enabled) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            var _text$sorting;
            const tooltips = getTooltipText('sorting', {
              tooltip
            });
            return jsx$1(TableSettingsSortingOptions, {
              size: headerActionSize,
              icon: field == null ? void 0 : field.icon,
              selected: sortingType,
              text: (_text$sorting = text == null ? void 0 : text.sorting) != null ? _text$sorting : defaultText$2 == null ? void 0 : defaultText$2.sorting,
              tooltip: omit(tooltips, ['enabled']),
              buttonProps: field.props,
              onChange: onTriggerSorting
            });
          }
        });
      }

      // ----- density
      if (type === 'density' && enabled) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            var _text$density;
            const tooltips = getTooltipText('density', {
              tooltip
            });
            return jsx$1(TableSettingsDensityOptions, {
              size: headerActionSize,
              icon: field == null ? void 0 : field.icon,
              text: (_text$density = text == null ? void 0 : text.density) != null ? _text$density : defaultText$2 == null ? void 0 : defaultText$2.density,
              tooltip: omit(tooltips, ['enabled']),
              buttonProps: field.props,
              onChange: onTriggerDensity
            });
          }
        });
      }

      // ----- expand
      if (type === 'expand' && !!headerExpandView && enabled) {
        var _field$icon$collapse, _field$icon2, _field$icon$expand, _field$icon3, _field$text$expand, _field$text, _field$text$collapse, _field$text2;
        const collapseIcon = (_field$icon$collapse = field == null || (_field$icon2 = field.icon) == null ? void 0 : _field$icon2.collapse) != null ? _field$icon$collapse : jsx$1(ExpandLessIcon, {});
        const expandIcon = (_field$icon$expand = field == null || (_field$icon3 = field.icon) == null ? void 0 : _field$icon3.expand) != null ? _field$icon$expand : jsx$1(ExpandMoreIcon, {});
        const finalExpandText = (_field$text$expand = field == null || (_field$text = field.text) == null ? void 0 : _field$text.expand) != null ? _field$text$expand : expandText;
        const finalCollapseText = (_field$text$collapse = field == null || (_field$text2 = field.text) == null ? void 0 : _field$text2.collapse) != null ? _field$text$collapse : collapseText;
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            const tooltips = getTooltipText('expand', {
              tooltip
            });
            return jsx$1(TooltipView, Object.assign({}, tooltips, {
              children: jsx$1(Button, Object.assign({
                variant: "text",
                size: headerActionSize
              }, field.props, {
                onClick: e => {
                  var _field$props;
                  const current = expanded != null ? expanded : false;
                  field == null || (_field$props = field.props) == null || _field$props.onClick == null ? void 0 : _field$props.onClick(e);
                  onTriggerExpand == null ? void 0 : onTriggerExpand(current, !current);
                },
                endIcon: expanded ? collapseIcon : expandIcon,
                children: expanded ? finalCollapseText : finalExpandText
              }))
            }));
          }
        });
      }

      // ----- custom
      if (type === 'custom') {
        viewList.push({
          key: `${field.key}-${i}`,
          render: () => {
            const tooltips = getTooltipText(field.key, {
              tooltip
            });
            return jsx$1(TooltipView, Object.assign({}, tooltips, {
              children: field.render == null ? void 0 : field.render({
                tableSize: headerActionSize,
                expanded: expanded != null ? expanded : false
              })
            }));
          }
        });
      }
    });
    return viewList;
  }, [text, headerActionSize, sortingType, createText, collapseText, headerExpandView, expandText, expanded, headerActions, onTriggerCreate, onTriggerRefresh, onTriggerSettings, onTriggerSorting, onTriggerExpand, onTriggerDensity]);
  return {
    views
  };
};

/**
 * ===========================
 * MAIN
 * ===========================
 */ // hooks to get header info
const useHeaderInfos = props => {
  const {
    title,
    totalRecord,
    totalSelected = 0,
    headerInfos,
    headerBulkOptions,
    headerActionSize,
    onTriggerBulkAction
  } = props;

  // =============== VIEWS
  const views = useMemo(() => {
    // -------- VARIABLES
    const viewList = [];
    const titleView = typeof title === 'function' ? title() : title;

    // ----- loop of actions
    forEach(headerInfos, (field, i) => {
      var _field$enabled;
      const type = field.type;
      const enabled = (_field$enabled = field.enabled) != null ? _field$enabled : true;

      // ----- create button
      if (type === 'title' && enabled && titleView) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            if (['string', 'number'].includes(typeof titleView)) {
              return jsx$1(Typography, {
                variant: "h6",
                children: titleView
              });
            }
            return jsx$1(Fragment, {
              children: titleView
            });
          }
        });
      }
      if (type === 'total' && enabled) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            var _field$text;
            return jsx$1(Typography, Object.assign({
              className: "crud-content-header-total-count"
            }, field.props, {
              children: replace$3((_field$text = field == null ? void 0 : field.text) != null ? _field$text : 'Total: {count}', '{count}', `${formatNumbering(totalRecord != null ? totalRecord : 0)}`)
            }));
          }
        });
      }
      if (type === 'bulk' && enabled && totalSelected > 0) {
        viewList.push({
          key: `${type}-${i}`,
          render: () => {
            return jsx$1(TableSelectedBulkOptions, Object.assign({
              size: headerActionSize,
              className: "crud-content-header-bulk-node",
              text: field == null ? void 0 : field.text,
              items: headerBulkOptions != null ? headerBulkOptions : field.items,
              total: totalSelected,
              onChange: onTriggerBulkAction
            }, field.props));
          }
        });
      }
    });
    return viewList;
  }, [title, totalSelected, totalRecord, headerInfos, headerActionSize, headerBulkOptions, onTriggerBulkAction]);
  return {
    views
  };
};

// Styled box
const StyledBox = styled(Box)(() => {
  return {
    '.crud-content-header-primary': {
      minHeight: 65,
      '.crud-content-header-infos': {},
      '.crud-content-header-actions': {}
    },
    '.crud-content-header-expanded-content': {},
    '.crud-content-header-tabview': {
      '.tabview-tabs-item': {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 48
      }
    }
  };
});

const CrudContentHeaderView = props => {
  const {
    expanded,
    headerTabs = [],
    headerTabsProps,
    headerTabState,
    headerCustomView: viewNode,
    headerExtraView: extraNode,
    headerExpandView: expandNode,
    onTabChange
  } = props;

  // =============== HOOKS
  const {
    views: headerInfoViews
  } = useHeaderInfos(props);
  const {
    views: headerActionViews
  } = useHeaderActionSettings(props);

  // =============== VARIABLES
  const hasInfos = headerInfoViews.length > 0;
  const hasActions = headerActionViews.length > 0;
  const hasTabs = headerTabs.length > 0;
  const hasExpand = !!expandNode;
  const hasExtra = !!extraNode;

  // =============== VIEW
  // if there is custom header render
  if (viewNode) {
    const view = typeof viewNode === 'function' ? viewNode() : viewNode;
    if (!view) return null;
    return jsxs(StyledBox, {
      className: "crud-content-header-wrapper",
      children: [view, jsx$1(TabView, Object.assign({}, headerTabsProps, {
        items: headerTabs,
        onChange: onTabChange
      }))]
    });
  }

  // default header
  if (!hasInfos && !hasActions && !hasTabs && !hasExpand && !hasExtra) {
    return null;
  }
  return jsxs(StyledBox, {
    className: "crud-content-header-wrapper",
    children: [(hasInfos || hasActions) && jsxs(Grid, {
      container: true,
      justifyContent: "start",
      alignItems: "center",
      className: "crud-content-header-primary",
      children: [headerInfoViews.length > 0 && jsx$1(Grid, {
        item: true,
        className: "crud-content-header-infos",
        children: jsx$1(RenderNodeView, {
          flexWrap: "wrap",
          alignItems: "center",
          direction: "row",
          spacing: 1,
          items: headerInfoViews.map(e => ({
            key: e.key,
            content: e.render
          }))
        })
      }), headerActionViews.length > 0 && jsxs(Fragment, {
        children: [jsx$1(Grid, {
          item: true,
          flex: "auto"
        }), jsx$1(Grid, {
          item: true,
          className: "crud-content-header-actions",
          children: jsx$1(RenderNodeView, {
            flexWrap: "wrap",
            alignItems: "center",
            direction: "row",
            spacing: 1,
            items: headerActionViews.map(e => ({
              key: e.key,
              content: e.render
            }))
          })
        })]
      })]
    }), expanded && jsx$1("div", {
      className: "crud-content-header-expanded-content",
      children: typeof expandNode === 'function' ? expandNode() : expandNode
    }), jsx$1(TabView, Object.assign({}, headerTabsProps, {
      className: cn('crud-content-header-tabview', headerTabsProps == null ? void 0 : headerTabsProps.className),
      value: headerTabState,
      items: headerTabs,
      onChange: onTabChange
    })), extraNode && jsx$1("div", {
      className: "crud-content-header-extra-content",
      children: typeof extraNode === 'function' ? extraNode() : extraNode
    })]
  });
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const CrudRowItemActions = /*#__PURE__*/memo(props => {
  const {
    data,
    node,
    type = 'icon',
    actions = [],
    renderActionButtons,
    renderExtraActionButtons
  } = props;

  // =============== HOOKS
  const {
    views,
    items
  } = useMemo(() => {
    let views = [];
    let items = [];

    // if render action button wasn't provided
    // then return empty array
    if (!renderActionButtons) {
      return {
        views,
        items
      };
    }
    const {
      viewButton,
      updateButton,
      deleteButton,
      exportButton,
      viewButtonNode,
      updateButtonNode,
      deleteButtonNode,
      exportButtonNode
    } = renderActionButtons({
      data
    });
    const extraAction = renderExtraActionButtons == null ? void 0 : renderExtraActionButtons({
      data
    });

    // ----------- loop actions
    forEach(actions, e => {
      // view button
      if (e === 'view' && isActionEnable(e, actions)) {
        if (viewButton) views.push(viewButton);
        if (viewButtonNode != null && viewButtonNode.node) {
          items.push({
            key: 'view',
            title: viewButtonNode == null ? void 0 : viewButtonNode.node,
            onClick: viewButtonNode.onClick,
            as: type === 'menu' ? viewButtonNode.node : null
          });
        }
      }
      // update button
      if (e === 'update' && isActionEnable(e, actions)) {
        if (updateButton) views.push(updateButton);
        if (updateButtonNode != null && updateButtonNode.node) {
          items.push({
            key: 'update',
            title: updateButtonNode.node,
            onClick: updateButtonNode.onClick,
            as: type === 'menu' ? updateButtonNode.node : null
          });
        }
      }
      // delete button
      if (e === 'delete' && isActionEnable(e, actions)) {
        if (deleteButton) views.push(deleteButton);
        if (deleteButtonNode != null && deleteButtonNode.node) {
          items.push({
            key: 'delete',
            title: deleteButtonNode.node,
            onClick: deleteButtonNode.onClick,
            as: type === 'menu' ? deleteButtonNode.node : null
          });
        }
      }
      // export button
      if (e === 'export' && isActionEnable(e, actions)) {
        if (exportButton) views.push(exportButton);
        if (exportButtonNode != null && exportButtonNode.node) {
          items.push({
            key: 'export',
            title: exportButtonNode.node,
            onClick: exportButtonNode.onClick,
            as: type === 'menu' ? exportButtonNode.node : null
          });
        }
      }
      if (e === 'extra' && isActionEnable(e, actions)) {
        var _extraAction$views, _extraAction$nodes;
        views = [...views, ...((_extraAction$views = extraAction == null ? void 0 : extraAction.views) != null ? _extraAction$views : [])];
        items = [...items, ...((_extraAction$nodes = extraAction == null ? void 0 : extraAction.nodes) != null ? _extraAction$nodes : []).map((e, i) => ({
          key: `extra-${i}`,
          title: e.node,
          onClick: e.onClick,
          as: type === 'menu' ? e.node : null
        }))];
      }
    });
    // ----------- return
    return {
      views,
      items
    };
  }, [type, data, actions, renderActionButtons, renderExtraActionButtons]);

  // =============== VIEW
  if (type === 'icon') {
    return jsx$1(Fragment, {
      children: views.map((e, i) => jsx$1(Fragment$1, {
        children: e
      }, i))
    });
  }
  return jsx$1(ButtonDropdown, {
    type: "icon",
    items: items,
    children: node
  });
});

/**
 * ===========================
 * MAIN
 * ===========================
 */
const defaultText$1 = {
  columnActionText: 'Action',
  nextText: 'Next',
  previousText: 'Previous',
  createText: 'Create',
  expandText: 'Expand',
  collapseText: 'Collapse',
  sorting: {
    default: 'Default',
    asc: 'Ascending',
    desc: 'Descending'
  },
  density: {
    default: 'Default',
    small: 'Small',
    medium: 'Medium'
  }
};
const defaultProps$1 = {
  data: [],
  page: 1,
  pageSize: 10,
  paginateType: 'pagination',
  itemActions: ['view'],
  headerActions: [],
  headerTabs: [],
  headerActionSize: 'medium',
  text: defaultText$1,
  headerInfos: [{
    type: 'title'
  }, {
    type: 'total'
  }, {
    type: 'bulk'
  }],
  expanded: false,
  enableItemAction: true,
  enableItemGroupAction: false,
  totalSelected: 0
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledWrapper$2 = styled(Box, {
  shouldForwardProp: prop => !['unstyled', 'spacingMultiplier'].includes(prop)
})(({
  theme,
  unstyled,
  spacingMultiplier
}) => {
  if (unstyled) return {};
  const hasMultiplier = !isNil(spacingMultiplier);
  return {
    '.crud-content-header-wrapper': {
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
      '.crud-content-header-primary': {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '.crud-content-header-infos': {},
        '.crud-content-header-actions': {}
      },
      '.crud-content-header-expanded-content': {
        borderBottom: `1px solid ${theme.palette.divider}`
      },
      '.crud-content-header-tabview': {},
      '.crud-content-header-extra-content': {
        borderTop: `1px solid ${theme.palette.divider}`
      }
    },
    '.crud-content-items-wrapper': {
      paddingTop: theme.spacing(hasMultiplier ? spacingMultiplier * 4 : 4),
      paddingBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 4 : 4)
    },
    '.crud-content-pagination-wrapper': {
      padding: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
      '.MuiPagination-ul': {
        justifyContent: 'center'
      }
    }
  };
});

const CrudContentView = props => {
  var _text$nextText, _text$previousText;
  const {
    className,
    text,
    data = [],
    page,
    title,
    checked = [],
    loading = false,
    pageSize = 10,
    paginateType,
    enableNext,
    enablePrevious,
    totalRecord = 0,
    totalSelected,
    enableItemGroupAction,
    itemActionGroupIcon,
    checkbox,
    itemActions,
    expanded,
    loadingView,
    emptyView,
    noDataView,
    headerCustomView,
    headerExpandView,
    headerExtraView,
    headerTabs,
    headerTabState,
    headerTabsProps,
    headerActions,
    headerActionSize = 'medium',
    headerInfos,
    unstyled,
    spacingMultiplier,
    paginationProps,
    onCheck,
    onTabChange,
    onPageChange,
    onPaginateNext,
    onPaginatePrevious,
    renderPagination,
    onTriggerBulkAction,
    onTriggerCreate,
    onTriggerRefresh,
    onTriggerSettings,
    onTriggerSorting,
    onTriggerDensity,
    onTriggerExpand,
    renderItemView,
    renderActionButtons,
    renderExtraActionButtons
  } = props;

  // =============== STATE
  const [sortingType, setSortingType] = useState('DEFAULT');
  const [shouldExpand, setShouldExpand] = useState(expanded != null ? expanded : false);
  const [checkedState, setCheckedState] = useState(checked);

  // =============== VARIABLES
  const hasData = (data == null ? void 0 : data.length) > 0;
  const nextText = (_text$nextText = text == null ? void 0 : text.nextText) != null ? _text$nextText : defaultText$1 == null ? void 0 : defaultText$1.nextText;
  const previousText = (_text$previousText = text == null ? void 0 : text.previousText) != null ? _text$previousText : defaultText$1 == null ? void 0 : defaultText$1.previousText;

  // =============== EFFECTS
  useEffect(() => setShouldExpand(!!expanded), [expanded]);
  const totalPage = useMemo(() => {
    return Math.ceil(totalRecord / pageSize);
  }, [totalRecord, pageSize]);

  // =============== HELPERS
  const triggerCheckboxUpdate = val => {
    setCheckedState(val);
    onCheck == null ? void 0 : onCheck(val);
  };
  const extractCheckedValue = val => {
    if (!(checkbox != null && checkbox.enabled)) return null;
    if (typeof val === 'number' || typeof val === 'string') {
      return val;
    }
    if (!checkbox.dataIndex) {
      return val;
    }
    return val == null ? void 0 : val[checkbox.dataIndex];
  };
  const checkedItemByRecord = (data, checked) => {
    const record = extractCheckedValue(data);
    if (isNil(record)) return;
    if (checked) {
      triggerCheckboxUpdate([...checkedState, record]);
    } else {
      triggerCheckboxUpdate(checkedState.filter(e => e !== record));
    }
  };
  const onHandleCheckbox = data => event => {
    event.stopPropagation();
    const isChecked = event.target.checked;
    checkedItemByRecord(data, isChecked);
  };

  // =============== EFFECTS
  useDeepCompareEffect(() => {
    triggerCheckboxUpdate(checked);
  }, [checked]);
  const renderPaginationView = () => {
    // custom render pagination
    if (renderPagination) {
      return renderPagination({
        page,
        total: totalRecord,
        data,
        pageSize,
        onPageChange
      });
    }
    // if paginate type = null
    if (paginateType === 'none') return null;

    // if paginate type = pagination
    if (paginateType === 'pagination') {
      return jsx$1(Pagination, Object.assign({
        color: "primary",
        page: page,
        count: totalPage,
        onChange: (e, p) => onPageChange == null ? void 0 : onPageChange(p)
      }, paginationProps));
    }
    return jsxs(Stack, {
      className: "crud-content-paginate-button",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      direction: "row",
      children: [jsx$1(Button, {
        size: headerActionSize,
        disabled: !enablePrevious,
        onClick: () => onPaginatePrevious == null ? void 0 : onPaginatePrevious(),
        children: previousText
      }), jsx$1(Button, {
        size: headerActionSize,
        disabled: !enableNext,
        onClick: () => onPaginateNext == null ? void 0 : onPaginateNext(),
        children: nextText
      })]
    });
  };
  const renderContentView = () => {
    // if loading
    if (loading) {
      return loadingView != null ? loadingView : jsx$1(Box, {
        sx: {
          padding: 20,
          textAlign: 'center'
        },
        children: jsx$1(CircularProgress, {
          size: 50
        })
      });
    }
    if (!hasData) {
      return emptyView != null ? emptyView : jsx$1(Typography$1, {
        py: 12,
        textAlign: "center",
        children: noDataView != null ? noDataView : 'No Data'
      });
    }
    if (!renderItemView) {
      return 'Please implement `renderItemView` for item rendering';
    }
    return data.map((record, i) => {
      const checkIndex = extractCheckedValue(record);
      const isChecked = checkIndex ? checkedState.includes(checkIndex) : false;
      return jsx$1(Fragment$1, {
        children: renderItemView(record, {
          checkbox: () => {
            if (!(checkbox != null && checkbox.enabled)) return null;
            return jsx$1(Checkbox, {
              color: "primary",
              checked: isChecked,
              onClick: e => e.stopPropagation(),
              onChange: onHandleCheckbox(record)
            });
          },
          action: () => {
            return jsx$1(CrudRowItemActions, {
              data: record,
              actions: itemActions,
              node: itemActionGroupIcon,
              type: enableItemGroupAction ? 'menu' : 'icon',
              renderActionButtons: renderActionButtons,
              renderExtraActionButtons: renderExtraActionButtons
            });
          }
        }, {
          checked: isChecked,
          onCheck: state => checkedItemByRecord(record, state)
        })
      }, `content-item-${i}`);
    });
  };

  // =============== VIEW
  return jsxs(StyledWrapper$2, {
    unstyled: unstyled,
    spacingMultiplier: spacingMultiplier,
    className: cn('crud-content-wrapper', className),
    children: [jsx$1(CrudContentHeaderView, {
      text: text,
      title: title,
      expanded: shouldExpand,
      sortingType: sortingType,
      totalRecord: totalRecord,
      totalSelected: totalSelected,
      headerCustomView: headerCustomView,
      headerExpandView: headerExpandView,
      headerTabs: headerTabs,
      headerTabState: headerTabState,
      headerTabsProps: headerTabsProps,
      headerInfos: headerInfos,
      headerActions: headerActions,
      headerActionSize: headerActionSize,
      headerExtraView: headerExtraView,
      onTabChange: onTabChange,
      onTriggerCreate: onTriggerCreate,
      onTriggerRefresh: onTriggerRefresh,
      onTriggerSettings: onTriggerSettings,
      onTriggerBulkAction: onTriggerBulkAction,
      onTriggerDensity: item => {
        onTriggerDensity == null ? void 0 : onTriggerDensity(item);
      },
      onTriggerSorting: item => {
        setSortingType(item);
        onTriggerSorting == null ? void 0 : onTriggerSorting(item);
      },
      onTriggerExpand: (current, next) => {
        setShouldExpand(next);
        onTriggerExpand == null ? void 0 : onTriggerExpand(current, next);
      }
    }), jsx$1("div", {
      className: "crud-content-items-wrapper",
      children: renderContentView()
    }), jsx$1("div", {
      className: "crud-content-pagination-wrapper",
      children: renderPaginationView()
    })]
  });
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
CrudContentView.defaultProps = defaultProps$1;

/**
 * ===========================
 * MAIN
 * ===========================
 */
const defaultText = {
  columnActionText: 'Action',
  nextText: 'Next',
  previousText: 'Previous',
  createText: 'Create',
  expandText: 'Expand',
  collapseText: 'Collapse',
  sorting: {
    default: 'Default',
    asc: 'Ascending',
    desc: 'Descending'
  },
  density: {
    default: 'Default',
    small: 'Small',
    medium: 'Medium'
  }
};
const defaultProps = {
  size: 'medium',
  data: [],
  columns: [],
  page: 1,
  pageSize: 10,
  paginateType: 'pagination',
  columnActions: ['view'],
  headerActions: [],
  headerTabs: [],
  headerActionSize: 'medium',
  text: defaultText,
  actionColumnPosition: 'last',
  headerInfos: [{
    type: 'title'
  }, {
    type: 'total'
  }, {
    type: 'bulk'
  }],
  expanded: false,
  enableActionColumn: true,
  enableItemGroupAction: false,
  totalSelected: 0
};

/**
 * ===========================
 * MAIN
 * ===========================
 */ // hooks to get table columns
const useColumnSettings = props => {
  const {
    size,
    columns,
    columnActions = [],
    text = defaultText,
    enableActionColumn,
    enableItemGroupAction = false,
    columnActionsGroupIcon,
    actionColumnProps = {},
    actionColumnExtraWidth,
    actionColumnPosition = 'last',
    renderActionButtons,
    renderExtraActionButtons
  } = props;
  const tableColumns = useMemo(() => {
    var _text$columnActionTex;
    const returnColumns = columns != null ? columns : [];
    if (!enableActionColumn || !renderActionButtons) {
      return returnColumns;
    }

    // =============== HELPERS

    const getActionColSize = () => {
      if (size === 'small') return 35;
      if (size === 'medium') return 50;
      return 60;
    };

    // action columns variables
    const actionLength = (columnActions != null ? columnActions : []).length > 1 && !enableItemGroupAction ? (columnActions != null ? columnActions : []).length : 1;

    // const isActionColLast = actionColumnPosition === 'last';
    // const isActionCoFirst = actionColumnPosition === 'first';
    // const colFixedRight = isActionColLast ? 'right' : undefined;
    // const colFixedLeft = isActionCoFirst ? 'left' : undefined;
    // const colFixed = colFixedRight ?? colFixedLeft;

    // action column settings
    const actionColumnConfig = Object.assign({
      key: 'action',
      title: (_text$columnActionTex = text == null ? void 0 : text.columnActionText) != null ? _text$columnActionTex : 'Action',
      align: 'center',
      width: actionLength * getActionColSize() + (actionColumnExtraWidth != null ? actionColumnExtraWidth : 0)
    }, actionColumnProps, {
      render: record => {
        return jsx$1(CrudRowItemActions, {
          data: record,
          actions: columnActions,
          node: columnActionsGroupIcon,
          type: enableItemGroupAction ? 'menu' : 'icon',
          renderActionButtons: renderActionButtons,
          renderExtraActionButtons: renderExtraActionButtons
        });
      }
    });

    // return column config
    if (actionColumnPosition === 'first') {
      return [actionColumnConfig, ...returnColumns];
    }
    if (typeof actionColumnPosition === 'number') {
      return [...returnColumns.slice(0, actionColumnPosition), actionColumnConfig, ...returnColumns.slice(actionColumnPosition)];
    }

    // usually position will be the last
    return [...returnColumns, actionColumnConfig];
  }, [size, text, columns, columnActions, enableActionColumn, columnActionsGroupIcon, actionColumnExtraWidth, actionColumnProps, actionColumnPosition, enableItemGroupAction, renderActionButtons, renderExtraActionButtons]);
  return tableColumns;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledWrapper$1 = styled(Box, {
  shouldForwardProp: prop => !['unstyled', 'spacingMultiplier'].includes(prop)
})(({
  theme,
  unstyled
}) => {
  if (unstyled) return {};
  return {
    background: theme.palette.background.paper,
    '.crud-content-header-wrapper': {
      '.crud-content-header-primary': {
        borderBottom: `1px solid ${theme.palette.divider}`,
        '.crud-content-header-infos': {},
        '.crud-content-header-actions': {}
      },
      '.crud-content-header-expanded-content': {
        borderBottom: `1px solid ${theme.palette.divider}`
      },
      '.crud-content-header-tabview': {},
      '.crud-content-header-extra-content': {
        borderTop: `1px solid ${theme.palette.divider}`
      }
    }
  };
});

const CrudTableView = props => {
  var _text$nextText, _text$previousText;
  const {
    className,
    size,
    text,
    data,
    page,
    title,
    checked,
    loading,
    pageSize,
    paginateType,
    enableNext,
    enablePrevious,
    totalRecord,
    totalSelected,
    tableProps,
    expanded,
    headerCustomView,
    headerExpandView,
    headerExtraView,
    headerTabs,
    headerTabState,
    headerTabsProps,
    headerActions,
    headerActionSize,
    headerInfos,
    unstyled,
    spacingMultiplier,
    emptyView,
    noDataView,
    onCheck,
    onColumnSort,
    onTabChange,
    onPageChange,
    onPageSizeChange,
    onPaginateNext,
    onPaginatePrevious,
    renderPagination,
    onTriggerBulkAction,
    onTriggerCreate,
    onTriggerRefresh,
    onTriggerSettings,
    onTriggerSorting,
    onTriggerDensity,
    onTriggerExpand
  } = props;

  // =============== STATE
  const [tableSize, setTableSize] = useState('medium');
  const [sortingType, setSortingType] = useState('DEFAULT');
  const [shouldExpand, setShouldExpand] = useState(expanded != null ? expanded : false);

  // =============== VARIABLES
  const nextText = (_text$nextText = text == null ? void 0 : text.nextText) != null ? _text$nextText : defaultText == null ? void 0 : defaultText.nextText;
  const previousText = (_text$previousText = text == null ? void 0 : text.previousText) != null ? _text$previousText : defaultText == null ? void 0 : defaultText.previousText;

  // =============== HOOKS
  const tableColumns = useColumnSettings(props);

  // =============== EFFECTS
  useEffect(() => setShouldExpand(!!expanded), [expanded]);

  // =============== VIEW
  const renderPaginationView = args => {
    var _renderPagination;
    // if the paginate type = `none` return null
    if (includes(['none'], paginateType)) return null;
    // custom render pagination
    if (renderPagination) return (_renderPagination = renderPagination(args)) != null ? _renderPagination : jsx$1(Fragment, {});
    // if paginate type = `pagination` should return null as well as we doesn't want override existing view
    if (includes(['pagination'], paginateType)) return null;
    return jsxs(Stack, {
      className: "crud-table-paginate-button",
      justifyContent: "end",
      alignItems: "center",
      flexWrap: "wrap",
      direction: "row",
      children: [jsx$1(Button, {
        size: size,
        disabled: !enablePrevious,
        onClick: () => onPaginatePrevious == null ? void 0 : onPaginatePrevious(),
        children: previousText
      }), jsx$1(Button, {
        size: size,
        disabled: !enableNext,
        onClick: () => onPaginateNext == null ? void 0 : onPaginateNext(),
        children: nextText
      })]
    });
  };
  return jsx$1(StyledWrapper$1, {
    unstyled: unstyled,
    spacingMultiplier: spacingMultiplier,
    className: cn('crud-table-wrapper', className),
    children: jsx$1(Table, Object.assign({
      size: tableSize,
      data: data,
      page: page,
      loading: loading,
      checked: checked,
      total: totalRecord,
      columns: tableColumns,
      pageSize: pageSize,
      pagination: paginateType !== 'none',
      emptyView: emptyView,
      noDataView: noDataView,
      topView: jsx$1(CrudContentHeaderView, {
        text: text,
        title: title,
        expanded: shouldExpand,
        sortingType: sortingType,
        totalRecord: totalRecord,
        totalSelected: totalSelected,
        headerCustomView: headerCustomView,
        headerExpandView: headerExpandView,
        headerTabs: headerTabs,
        headerTabState: headerTabState,
        headerTabsProps: headerTabsProps,
        headerInfos: headerInfos,
        headerActions: headerActions,
        headerActionSize: headerActionSize,
        headerExtraView: headerExtraView,
        onTabChange: onTabChange,
        onTriggerCreate: onTriggerCreate,
        onTriggerRefresh: onTriggerRefresh,
        onTriggerSettings: onTriggerSettings,
        onTriggerBulkAction: onTriggerBulkAction,
        onTriggerDensity: item => {
          setTableSize(item);
          onTriggerDensity == null ? void 0 : onTriggerDensity(item);
        },
        onTriggerSorting: item => {
          setSortingType(item);
          onTriggerSorting == null ? void 0 : onTriggerSorting(item);
        },
        onTriggerExpand: (current, next) => {
          setShouldExpand(next);
          onTriggerExpand == null ? void 0 : onTriggerExpand(current, next);
        }
      }),
      onCheck: onCheck,
      onColumnSort: onColumnSort,
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange,
      renderPagination: renderPaginationView
    }, tableProps))
  });
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
CrudTableView.defaultProps = defaultProps;

/**
 * ===========================
 * MAIN
 * ===========================
 */
const useCrudModalForm = props => {
  const {
    create,
    update,
    exports,
    extra
  } = props;

  // =============== HOOKS
  const options = useMemo(() => {
    // =============== HELPERS
    const onRenderNode = instance => {
      return ctx => {
        const {
          title,
          props: dialogProps = {},
          data,
          context,
          visible,
          mutation,
          accessibility,
          onHide,
          onShow
        } = ctx;
        return jsx$1(Dialog, Object.assign({
          type: "custom",
          title: title,
          enableCloseButton: true,
          visible: visible,
          onClose: () => onHide()
        }, dialogProps, {
          onClickAction: e => {
            onHide();
            dialogProps == null || dialogProps.onClickAction == null ? void 0 : dialogProps.onClickAction(e);
          },
          children: instance.render({
            data,
            context,
            visible,
            mutation,
            accessibility,
            onHide,
            onShow
          })
        }));
      };
    };

    // =============== CONSTRUCT
    return {
      // --- modal forms setting for create & update
      create: create ? {
        title: create.title,
        props: create.props,
        node: onRenderNode(create)
      } : undefined,
      update: update ? {
        title: update.title,
        props: update.props,
        node: onRenderNode(update)
      } : undefined,
      delete: props.delete ? {
        title: props.delete.title,
        props: props.delete.props,
        node: onRenderNode(props == null ? void 0 : props.delete)
      } : undefined,
      exports: exports ? {
        title: exports.title,
        props: exports.props,
        node: onRenderNode(exports)
      } : undefined,
      extra: extra ? reduce(extra != null ? extra : {}, (r, e, k) => {
        r[k] = {
          title: e.title,
          props: e.props,
          node: onRenderNode(e)
        };
        return r;
      }, {}) : undefined
    };
  }, [create, exports, props.delete, update, extra]);

  // =============== RETURN
  return options;
};

const MenuActionTextMap = {
  view: 'View',
  update: 'Update',
  delete: 'Delete',
  export: 'Export'
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
const useCrudTableItemAction = props => {
  const {
    size = 'small',
    text,
    name,
    identifier,
    nodeType = 'icon',
    links,
    enableView = true,
    enableUpdate = false,
    enableDelete = false,
    enableExport = false,
    enableExtra = true,
    enableAlert = ['delete', 'export'],
    tooltips = {},
    viewNode,
    updateNode,
    deleteNode,
    exportNode,
    extraActions = [],
    viewAction,
    updateAction,
    deleteAction,
    exportAction,
    title,
    message,
    resource
  } = props;

  // =============== HOOKS
  const buttons = useMemo(() => {
    // HELPERS
    const isEnableAlert = type => {
      return includes(enableAlert, type);
    };

    // render tooltip view
    const renderTooltip = (type, node, title) => {
      var _ref;
      const tooltipsValue = (_ref = title != null ? title : tooltips == null ? void 0 : tooltips[type]) != null ? _ref : true;

      // if tooltip doesn't enabled, just return node
      if (!tooltipsValue) return node;

      // if tooltip is boolean, then use default text as tooltip
      if (typeof tooltipsValue === 'boolean') {
        return jsx$1(TooltipView, {
          title: startCase(type),
          children: node
        });
      }

      // if tooltip is string, then use it as tooltip text
      if (typeof tooltipsValue === 'string') {
        return jsx$1(TooltipView, {
          title: tooltipsValue,
          children: node
        });
      }
      return jsx$1(TooltipView, Object.assign({}, tooltipsValue, {
        children: node
      }));
    };

    // render link
    const renderLink = (node, linking) => {
      const isLinkString = typeof linking === 'string';
      const url = isLinkString ? linking : linking == null ? void 0 : linking.path;
      const openNewTab = !isLinkString && linking != null && linking.openNewTab ? {
        target: '_blank'
      } : {};
      if (nodeType === 'menu') {
        return jsx$1(MenuItem$1, Object.assign({
          className: "crud-item-action-link"
        }, url ? Object.assign({
          component: NextLink,
          href: url
        }, openNewTab) : {}, {
          children: node
        }));
      }
      if (!url) return node;
      return jsx$1(NextLink, Object.assign({
        className: "crud-item-action-link",
        href: url
      }, openNewTab, {
        children: node
      }));
    };

    // render actin node
    const renderActionNode = (viewer, type, node, title, linking) => (ctx, clickEvent) => {
      const link = linking == null ? void 0 : linking(ctx);
      if (typeof viewer === 'boolean' && !viewer) {
        return null;
      }
      if (typeof viewer === 'function' && !viewer(ctx)) {
        return null;
      }

      // if node type = function
      if (typeof node === 'function') {
        return renderTooltip(type, node(ctx, clickEvent), title);
      }

      // if node type = menu
      if (nodeType === 'menu') {
        var _ref2;
        return renderLink(jsxs(Stack, {
          className: cn('crud-item-action-menu-type', type),
          alignItems: "center",
          direction: "row",
          width: "100%",
          children: [node, jsxs("span", {
            children: ["\xA0", (_ref2 = title != null ? title : text == null ? void 0 : text[`${type}Text`]) != null ? _ref2 : MenuActionTextMap[type]]
          })]
        }), link);
      }

      /**
       * nodeType = `button` / `icon`
       * -------------------------
       */
      // default to icon button
      let buttonNode = jsx$1(IconButton, {
        className: cn('crud-item-action-button-type', type),
        size: size,
        "aria-label": type,
        onClick: !linking ? clickEvent : undefined,
        children: node
      });
      // if button type
      if (nodeType === 'button') {
        buttonNode = jsx$1(Button, {
          className: cn('crud-item-action-button-type', type),
          size: size,
          "aria-label": type,
          onClick: !linking ? clickEvent : undefined,
          children: node
        });
      }
      return renderTooltip(type, renderLink(buttonNode, link), title);
    };

    /**
    // render alert node
    const renderAlertNode = (options) => {
      return (
        <Dialog
          {...dialogProps}
          type="confirmation"
          fullWidth
          maxWidth="sm"
          visible={true}
          title={options.title}
          message={options.message ?? ''}
          onClickAction={(action) => {
            if (action === 'primary') {
              options.onPrimary();
              return;
            }
            options.onSecondary();
          }}
        />
      );
    };
     */

    // ========== RETURN
    return {
      view: {
        onClick: !(links != null && links.view) ? (e, ctx) => {
          var _ctx$context, _ctx$data, _ctx$context2;
          if (!ctx) return;
          if (viewAction) {
            viewAction(e, ctx);
            return;
          }
          if (!ctx.data) return;
          (_ctx$context = ctx.context) == null || (_ctx$context = _ctx$context.detail) == null ? void 0 : _ctx$context.query({
            variables: {
              id: (_ctx$data = ctx.data) == null ? void 0 : _ctx$data.id
            }
          });
          (_ctx$context2 = ctx.context) == null || (_ctx$context2 = _ctx$context2.controllers) == null || (_ctx$context2 = _ctx$context2.details) == null ? void 0 : _ctx$context2.onShow();
        } : undefined,
        // NOTE: we can have custom alert node just like example below
        // alert: !isEnableAlert('view') ? false : renderAlertNode,
        alert: !(links != null && links.view) && isEnableAlert('view'),
        node: renderActionNode(enableView, 'view', viewNode != null ? viewNode : jsx$1(RemoveRedEyeOutlinedIcon, {
          fontSize: "inherit"
        }), undefined, links == null ? void 0 : links.view)
      },
      update: {
        onClick: !(links != null && links.update) ? (e, ctx) => {
          var _ctx$context3;
          if (!ctx) return;
          if (updateAction) {
            updateAction(e, ctx);
            return;
          }
          const data = ctx == null ? void 0 : ctx.data;
          (_ctx$context3 = ctx.context) == null || (_ctx$context3 = _ctx$context3.controllers) == null || (_ctx$context3 = _ctx$context3.update) == null ? void 0 : _ctx$context3.onShow(data);
        } : undefined,
        alert: !(links != null && links.update) && isEnableAlert('update'),
        node: renderActionNode(enableUpdate, 'update', updateNode != null ? updateNode : jsx$1(ModeEditOutlineOutlinedIcon, {
          fontSize: "inherit"
        }), undefined, links == null ? void 0 : links.update)
      },
      delete: {
        onClick: !(links != null && links.delete) ? (e, ctx) => {
          var _ctx$context4;
          if (!ctx) return;
          if (deleteAction) {
            deleteAction(e, ctx);
            return;
          }
          const data = ctx == null ? void 0 : ctx.data;
          (_ctx$context4 = ctx.context) == null || (_ctx$context4 = _ctx$context4.controllers) == null || (_ctx$context4 = _ctx$context4.delete) == null ? void 0 : _ctx$context4.onShow(data);
        } : undefined,
        alert: !(links != null && links.delete) && isEnableAlert('delete'),
        node: renderActionNode(enableDelete, 'delete', deleteNode != null ? deleteNode : jsx$1(DeleteOutlineOutlinedIcon, {
          fontSize: "inherit"
        }), undefined, links == null ? void 0 : links.delete)
      },
      exports: {
        onClick: !(links != null && links.export) ? (e, ctx) => {
          var _ctx$context5;
          if (!ctx) return;
          if (exportAction) {
            exportAction(e, ctx);
            return;
          }
          const data = ctx == null ? void 0 : ctx.data;
          (_ctx$context5 = ctx.context) == null || (_ctx$context5 = _ctx$context5.controllers) == null || (_ctx$context5 = _ctx$context5.exports) == null ? void 0 : _ctx$context5.onShow(data);
        } : undefined,
        alert: !(links != null && links.export) && isEnableAlert('export'),
        node: renderActionNode(enableExport, 'export', exportNode != null ? exportNode : jsx$1(CloudDownloadOutlinedIcon, {
          fontSize: "inherit"
        }), undefined, links == null ? void 0 : links.export)
      },
      extra: extraActions.reduce((result, action) => {
        var _ref3, _action$enabled, _action$node;
        const tooltipTitle = !isNil(action.tooltip) ? action.tooltip || action.title : action.title;
        result.push({
          key: action.key,
          title: action.title,
          alert: !action.link && action.alert,
          node: renderActionNode((_ref3 = (_action$enabled = action.enabled) != null ? _action$enabled : enableExtra) != null ? _ref3 : true, action.key, (_action$node = action == null ? void 0 : action.node) != null ? _action$node : jsx$1(ExpandCircleDownOutlinedIcon, {
            fontSize: "inherit"
          }), tooltipTitle, action.link),
          onClick: !action.link ? action.action : undefined
        });
        return result;
      }, []),
      text,
      title: title ? context => title(context) : undefined,
      message: message ? context => message(context) : undefined,
      resource: identifier ? context => {
        var _context$data;
        if (resource) return resource(context);
        return {
          name,
          identifier: identifier ? context == null || (_context$data = context.data) == null ? void 0 : _context$data[identifier] : null
        };
      } : undefined
    };
  }, [name, size, text, links, identifier, nodeType, tooltips, viewNode, updateNode, deleteNode, exportNode, enableAlert, enableView, enableUpdate, enableDelete, enableExtra, enableExport, extraActions, title, message, resource, viewAction, updateAction, deleteAction, exportAction]);

  // =============== RETURN
  return buttons;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
function useCrudProps(props) {
  var _columnActions$extraA2;
  const {
    name,
    schema,
    columns,
    unstyled,
    pageTitle,
    pageActions,
    pageBackPath,
    checked = [],
    pageBreadcrumbs = [],
    tableTitle,
    tableTabs,
    tableTabState,
    tableInfos,
    tableActions,
    tableExpandView,
    tableExpandState,
    tableExtraView,
    variables = {},
    events,
    paging,
    alertProps,
    modalForms = {},
    filterTitle,
    filterNode,
    filterActions,
    columnActions,
    columnDataIndex,
    columnExtraActions = [],
    columnActionSequence = ['view', 'update', 'delete', 'export', 'extra'],
    detailsViewType = 'drawer',
    filterModalViewType = 'drawer',
    emptyView,
    noDataView,
    enableDetailView = true,
    enableNotification = true,
    enableRowSelection = true,
    enableActionColumn = true,
    enableItemGroupAction = false,
    spacingMultiplier,
    onTableTabChange,
    onTableItemCheck,
    onTableColumnSort,
    prepareAlertProps,
    prepareHeaderViewProps,
    prepareFilterViewProps,
    prepareTableViewProps,
    prepareContentViewProps,
    prepareDetailViewProps,
    prepareFilterModalViewProps,
    renderDetailsView,
    renderFilterModalView,
    renderNotificationView,
    renderItemView
  } = props;

  // =================== VARIABLES
  const tableActionState = useMemo(() => {
    var _columnActions$extraA;
    return {
      view: enableDetailView || !!(columnActions != null && columnActions.enableView),
      update: !!(modalForms != null && modalForms.update) || !!(columnActions != null && columnActions.enableUpdate),
      delete: !!(schema != null && schema.delete) || !!(columnActions != null && columnActions.enableDelete),
      export: !!(schema != null && schema.exports) || !!(columnActions != null && columnActions.enableExport),
      extra: (columnActions == null ? void 0 : columnActions.enableExtra) || (columnActions == null || (_columnActions$extraA = columnActions.extraActions) == null ? void 0 : _columnActions$extraA.length) || columnExtraActions.length
    };
  }, [schema, columnActions, columnExtraActions, enableDetailView, modalForms]);
  const tableActionList = useMemo(() => {
    const enabledColumns = reduce(tableActionState, (r, e, k) => {
      if (e) {
        switch (k) {
          case 'view':
            r.push('view');
            break;
          case 'update':
            r.push('update');
            break;
          case 'delete':
            r.push('delete');
            break;
          case 'export':
            r.push('export');
            break;
          case 'extra':
            r.push('extra');
            break;
        }
      }
      return r;
    }, []);
    if (columnActionSequence.length === 0) {
      return enabledColumns;
    }
    const arranged = columnActionSequence.reduce((r, e) => {
      if (enabledColumns != null && enabledColumns.includes(e)) {
        r.push(e);
      }
      return r;
    }, []);
    if (arranged.length === enabledColumns.length) {
      return arranged;
    }
    const leftover = enabledColumns.filter(e => !arranged.includes(e));
    return [...arranged, ...leftover];
  }, [tableActionState, columnActionSequence]);

  // =================== CRUD
  const crud = new CRUD(name, schema, {
    paging,
    events,
    enableNotification,
    enableRowSelection,
    nodes: {
      /**
       * --------------------------
       * NOTIFICATION
       * --------------------------
       */
      notification: options => {
        const {
          type,
          message
        } = options;
        if (renderNotificationView) {
          renderNotificationView(options);
          return;
        }
        if (type === 'success') {
          toast.success(message);
          return;
        }
        toast.error(message);
      },
      /**
       * --------------------------
       * ALERT VIEW
       * --------------------------
       */
      alert: props => {
        const viewProps = prepareAlertProps == null ? void 0 : prepareAlertProps(props);
        return jsx$1(Dialog, Object.assign({
          type: "confirmation",
          fullWidth: true,
          onClose: props.onHide,
          visible: props.visible,
          title: props.title,
          message: props.message,
          primaryText: props.primaryText,
          secondaryText: props.secondaryText,
          onClickAction: action => {
            if (action === 'primary') {
              props.onPrimary();
              return;
            }
            props.onSecondary();
          }
        }, alertProps, viewProps));
      },
      /**
       * --------------------------
       * PAGE HEADER VIEW
       * --------------------------
       */
      pageHeader: nodeProps => {
        const viewProps = prepareHeaderViewProps == null ? void 0 : prepareHeaderViewProps(nodeProps);
        return jsx$1(CrudPageHeaderView, Object.assign({
          unstyled: unstyled,
          title: pageTitle,
          actions: pageActions,
          backPath: pageBackPath,
          items: pageBreadcrumbs,
          spacingMultiplier: spacingMultiplier
        }, viewProps));
      },
      /**
       * --------------------------
       * FILTER VIEW
       * --------------------------
       */
      filter: nodeProps => {
        var _viewProps$children;
        const viewProps = prepareFilterViewProps == null ? void 0 : prepareFilterViewProps(nodeProps);
        return jsx$1(CrudFilterView, Object.assign({
          unstyled: unstyled,
          title: filterTitle,
          actions: filterActions,
          spacingMultiplier: spacingMultiplier
        }, viewProps != null ? viewProps : {}, {
          children: (_viewProps$children = viewProps == null ? void 0 : viewProps.children) != null ? _viewProps$children : filterNode
        }));
      },
      /**
       * --------------------------
       * DETAIL VIEW
       * --------------------------
       */
      details: nodeProps => {
        const {
          visible,
          onHide
        } = nodeProps;
        const viewProps = prepareDetailViewProps == null ? void 0 : prepareDetailViewProps(nodeProps);
        if (detailsViewType === 'modal') {
          const modalProps = viewProps == null ? void 0 : viewProps.modalProps;
          return jsx$1(Dialog, Object.assign({
            type: "custom",
            fullWidth: true,
            maxWidth: "md",
            visible: visible,
            onClose: onHide,
            enableCloseButton: true
          }, modalProps, {
            onClickAction: () => {
              onHide();
            },
            children: renderDetailsView == null ? void 0 : renderDetailsView(nodeProps)
          }));
        }
        const drawerProps = viewProps == null ? void 0 : viewProps.drawerProps;
        return jsx$1(SwipeableDrawer, Object.assign({
          anchor: "right"
        }, drawerProps, {
          onOpen: () => null,
          PaperProps: Object.assign({
            sx: {
              backgroundColor: 'background.paper',
              width: '50%'
            }
          }, drawerProps == null ? void 0 : drawerProps.PaperProps),
          sx: Object.assign({
            width: '50%'
          }, drawerProps == null ? void 0 : drawerProps.sx),
          open: visible,
          onClose: onHide,
          children: renderDetailsView == null ? void 0 : renderDetailsView(nodeProps)
        }));
      },
      /**
       * --------------------------
       * FILTER MODAL VIEW
       * --------------------------
       */
      filterModal: nodeProps => {
        var _renderFilterModalVie, _viewProps$children2;
        const {
          visible,
          onHide
        } = nodeProps;
        const viewProps = prepareFilterModalViewProps == null ? void 0 : prepareFilterModalViewProps(nodeProps);
        const renderFilterContentView = (_renderFilterModalVie = renderFilterModalView == null ? void 0 : renderFilterModalView(nodeProps)) != null ? _renderFilterModalVie : jsx$1(CrudFilterView, Object.assign({
          unstyled: unstyled,
          title: filterTitle,
          actions: filterActions,
          spacingMultiplier: spacingMultiplier
        }, viewProps != null ? viewProps : {}, {
          children: (_viewProps$children2 = viewProps == null ? void 0 : viewProps.children) != null ? _viewProps$children2 : filterNode
        }));

        // if filter view is in modal form
        if (filterModalViewType === 'modal') {
          const modalProps = viewProps == null ? void 0 : viewProps.modalProps;
          return jsx$1(Dialog, Object.assign({
            type: "custom",
            fullWidth: true,
            maxWidth: "md",
            visible: visible,
            onClose: onHide,
            enableCloseButton: true
          }, modalProps, {
            onClickAction: e => {
              onHide();
              modalProps == null || modalProps.onClickAction == null ? void 0 : modalProps.onClickAction(e);
            },
            children: renderFilterContentView
          }));
        }

        // if filter view is in drawer form
        const drawerProps = viewProps == null ? void 0 : viewProps.drawerProps;
        return jsx$1(SwipeableDrawer, Object.assign({
          anchor: "right"
        }, drawerProps, {
          onOpen: () => null,
          PaperProps: Object.assign({
            sx: {
              width: '50%',
              backgroundColor: 'background.paper'
            }
          }, drawerProps == null ? void 0 : drawerProps.PaperProps),
          sx: Object.assign({
            width: '50%'
          }, drawerProps == null ? void 0 : drawerProps.sx),
          open: visible,
          onClose: onHide,
          children: renderFilterContentView
        }));
      },
      /**
       * --------------------------
       * TABLE VIEW
       * --------------------------
       */
      table: nodeProps => {
        var _pagingProps$data$tot;
        const {
          data,
          loading,
          pagination,
          accessibility,
          context,
          rowSelection,
          renderActionButtons,
          renderExtraActionButtons
        } = nodeProps;
        const {
          pagingProps
        } = context;
        const viewProps = prepareTableViewProps == null ? void 0 : prepareTableViewProps(nodeProps);
        const selectable = rowSelection.isSelectable;
        const restViewProps = omit(viewProps != null ? viewProps : {}, ['tableProps']);
        return jsx$1(CrudTableView, Object.assign({
          data: data,
          title: tableTitle,
          loading: loading,
          columns: columns,
          headerTabs: tableTabs,
          headerTabState: tableTabState,
          headerInfos: tableInfos,
          headerActions: tableActions,
          headerExpandView: tableExpandView,
          headerExtraView: tableExtraView,
          expanded: tableExpandState,
          emptyView: emptyView,
          noDataView: noDataView,
          page: pagination.current,
          pageSize: pagination.defaultPageSize,
          pageSizeOptions: viewProps == null ? void 0 : viewProps.pageSizeOptions,
          totalRecord: (_pagingProps$data$tot = pagingProps.data.total) != null ? _pagingProps$data$tot : 0,
          totalSelected: accessibility.totalSelected,
          enableActionColumn: enableActionColumn,
          enableItemGroupAction: enableItemGroupAction,
          enableNext: accessibility.enableNext,
          enablePrevious: accessibility.enablePrevious,
          columnActions: tableActionList,
          onCheck: data => {
            rowSelection.setSelections(data);
            onTableItemCheck == null ? void 0 : onTableItemCheck(data);
          },
          onColumnSort: onTableColumnSort,
          onPageSizeChange: size => {
            pagingProps.onUpdatePageSize(size);
          },
          onPageChange: page => {
            pagination.paginateTo(page);
          },
          onTabChange: onTableTabChange,
          onPaginateNext: pagingProps.onPaginateNext,
          onPaginatePrevious: pagingProps.onPaginatePrevious,
          onTriggerCreate: accessibility.onTriggerCreate,
          onTriggerRefresh: accessibility.onTriggerRefresh,
          onTriggerSorting: accessibility.onTriggerSorting,
          renderActionButtons: renderActionButtons,
          renderExtraActionButtons: renderExtraActionButtons
        }, restViewProps, {
          tableProps: Object.assign({
            enableTableHeadDivider: true
          }, viewProps == null ? void 0 : viewProps.tableProps, {
            checkbox: {
              enabled: selectable,
              dataIndex: columnDataIndex
            },
            checked: (checked == null ? void 0 : checked.length) === 0 ? rowSelection.selections : checked
          })
        }));
      },
      /**
       * --------------------------
       * CONTENT VIEW
       * --------------------------
       */
      content: nodeProps => {
        var _pagingProps$data$tot2;
        const {
          data,
          loading,
          pagination,
          accessibility,
          context,
          rowSelection,
          renderActionButtons,
          renderExtraActionButtons
        } = nodeProps;
        const {
          pagingProps
        } = context;
        const viewProps = prepareContentViewProps == null ? void 0 : prepareContentViewProps(nodeProps);
        const selectable = rowSelection.isSelectable;
        return jsx$1(CrudContentView, Object.assign({
          data: data,
          title: tableTitle,
          loading: loading,
          headerTabs: tableTabs,
          headerTabState: tableTabState,
          headerInfos: tableInfos,
          headerActions: tableActions,
          headerExpandView: tableExpandView,
          headerExtraView: tableExtraView,
          expanded: tableExpandState,
          emptyView: emptyView,
          noDataView: noDataView,
          page: pagination.current,
          pageSize: pagination.defaultPageSize,
          totalRecord: (_pagingProps$data$tot2 = pagingProps.data.total) != null ? _pagingProps$data$tot2 : 0,
          totalSelected: accessibility.totalSelected,
          enableItemAction: enableActionColumn,
          enableItemGroupAction: enableItemGroupAction,
          enableNext: accessibility.enableNext,
          enablePrevious: accessibility.enablePrevious,
          itemActions: tableActionList,
          checked: (checked == null ? void 0 : checked.length) === 0 ? rowSelection.selections : checked,
          checkbox: {
            enabled: selectable,
            dataIndex: columnDataIndex
          },
          onCheck: data => {
            rowSelection.setSelections(data);
            onTableItemCheck == null ? void 0 : onTableItemCheck(data);
          },
          onPageChange: page => {
            pagination.paginateTo(page);
          },
          onTabChange: onTableTabChange,
          onPaginateNext: pagingProps.onPaginateNext,
          onPaginatePrevious: pagingProps.onPaginatePrevious,
          onTriggerCreate: accessibility.onTriggerCreate,
          onTriggerRefresh: accessibility.onTriggerRefresh,
          onTriggerSorting: accessibility.onTriggerSorting,
          renderActionButtons: renderActionButtons,
          renderExtraActionButtons: renderExtraActionButtons,
          renderItemView: renderItemView
        }, viewProps));
      }
    },
    /**
     * --------------------------
     * ITEM ACTIONS
     * --------------------------
     */
    itemActions: useCrudTableItemAction(Object.assign({
      name
    }, columnActions != null ? columnActions : {}, {
      extraActions: (_columnActions$extraA2 = columnActions == null ? void 0 : columnActions.extraActions) != null ? _columnActions$extraA2 : columnExtraActions,
      nodeType: enableItemGroupAction ? 'menu' : columnActions == null ? void 0 : columnActions.nodeType
    })),
    /**
     * --------------------------
     * MODAL FORMS CONFIGURATION
     * --------------------------
     */
    modalForms: useCrudModalForm(modalForms != null ? modalForms : {})
  });
  const crudProps = crud.use(variables);
  return crudProps;
}

/**
 * ===========================
 * MAIN
 * ===========================
 */
const StyledWrapper = styled(Box, {
  shouldForwardProp: prop => !['unstyled', 'spacingMultiplier'].includes(prop)
})(({
  theme,
  unstyled,
  spacingMultiplier
}) => {
  if (unstyled) return {};
  const hasMultiplier = !isNil(spacingMultiplier);
  return {
    '.crud-page-header-wrapper': {
      marginBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 3 : 3)
    },
    '.crud-filter-wrapper': {
      borderRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
      padding: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
      marginBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 3 : 3)
    },
    '.crud-table-wrapper': {
      borderRadius: 10,
      border: `1px solid ${theme.palette.divider}`,
      marginTop: theme.spacing(hasMultiplier ? spacingMultiplier * 3 : 3),
      '.crud-content-header-primary': {
        paddingTop: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingLeft: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingRight: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2)
      }
    },
    '.crud-content-wrapper': {
      marginTop: theme.spacing(hasMultiplier ? spacingMultiplier * 3 : 3),
      '.crud-content-header-primary': {
        paddingTop: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingBottom: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingLeft: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2),
        paddingRight: theme.spacing(hasMultiplier ? spacingMultiplier * 2 : 2)
      }
    }
  };
});

function CrudPanelViewComponent(props, ref) {
  const {
    className,
    unstyled,
    spacingMultiplier,
    contentViewType = 'table',
    enablePageHeader = true,
    enableFilterView = true,
    enableDetailView = true,
    enableFilterModalView = true
  } = props;

  // =============== HOOKS
  const crudProps = useCrudProps(props);
  useImperativeHandle(ref, () => crudProps);

  // =============== VARIABLES
  const {
    components
  } = crudProps;
  const {
    renderAlert,
    renderDetails,
    renderContent,
    renderFilter,
    renderTable,
    renderPageHeader,
    renderModalForms,
    renderFilterModal
  } = components;

  // =============== VIEWS
  return jsxs(StyledWrapper, {
    unstyled: unstyled,
    spacingMultiplier: spacingMultiplier,
    className: cn('crud-panel-wrapper', className),
    children: [renderAlert == null ? void 0 : renderAlert(), enablePageHeader && (renderPageHeader == null ? void 0 : renderPageHeader()), enableFilterView && (renderFilter == null ? void 0 : renderFilter()), contentViewType === 'table' && (renderTable == null ? void 0 : renderTable()), contentViewType === 'view' && (renderContent == null ? void 0 : renderContent()), enableDetailView && (renderDetails == null ? void 0 : renderDetails()), renderModalForms == null ? void 0 : renderModalForms(), enableFilterModalView && (renderFilterModal == null ? void 0 : renderFilterModal())]
  });
}
const CrudPanelView = /*#__PURE__*/forwardRef(CrudPanelViewComponent);

export { BreadcrumbView, ButtonDropdown, CrudFilterView, CrudPageHeaderView, CrudPanelView, CrudTableView, Dialog, NumberFormatView, RenderFlexView, RenderNodeView, TabView, Table, TableHead, TablePagination, TableRow, TableSelectedBulkOptions, TableSettingsDensityOptions, TableSettingsOptions, TableSettingsSortingOptions, TooltipView, useCrudModalForm, useCrudTableItemAction };
